<template>
  <div class="main-container">
    <div v-show="!signLayer">
      <div v-if="!sidExpired"  class="singVerify">
        <div class="singVerify-head">
          <img class="img" src="@/assets/images/sign/dunpai.png" alt="">
          <img class="txt" src="@/assets/images/sign/qianshuyiyuan.png" alt="">
        </div>
        <div v-if="!singVerifySuccess" class="signVerify-body">
          <img class="tiao"  src="@/assets/images/sign/tiao.png" alt="">
          <el-form ref="form" :model="singVerifyForm"  class="signVerify-form" label-position="left">
            <el-form-item label="任务主题：" label-width="90px">
              {{singVerifyForm.taskName}}
            </el-form-item>
            <el-form-item label="发起方：" label-width="90px">
              {{singVerifyForm.initiatorName}}
            </el-form-item>
            <el-form-item label="签署方：" label-width="90px">
              <span v-if="singVerifyForm.signSubject=='company'">{{singVerifyForm.signerName}}({{singVerifyForm.companyName}})</span>
              <span v-else>{{singVerifyForm.signerName}}</span>

            </el-form-item>
            <el-form-item style="height: 0;border: 1px dashed #D8D8D8;"></el-form-item>

            <template v-if="signStatusDialog=='iSign'">
            <el-form-item label="验证方式：" label-width="90px">
              <el-radio-group v-model="singVerifyForm.authWaysValue" @input="authWaysChange">
                <el-radio v-for="(it,i) in singVerifyForm.authWaysArr" :key="i" :label="it.label">{{it.value}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="singVerifyForm.authWaysValue=='sms'" label="验证码将发送至您的手机：" label-width="180px">
              {{singVerifyForm.phone}}
            </el-form-item>
            <el-form-item v-if="singVerifyForm.authWaysValue=='sms'">
              <el-input  placeholder="请输入短信验证码" maxlength="6" v-model.trim="singVerifyForm.vcode" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              <div class="code-btn">
                <el-button class="right-btn"  type="primary" plain :disabled="!sendCode"
                           @click="getMsgAuthCode" v-show="sendCode">获取验证码</el-button>
                <el-button type="primary" plain v-show="!sendCode" class="right-btn">
                  重新获取({{ auth_time }})秒</el-button>
              </div>
              <div v-show="sendCodeAlert" class="alert">{{sendCodeAlertMsg}}</div>
            </el-form-item>

            <el-form-item v-if="singVerifyForm.authWaysValue=='pin'" label="请输入签署密码" label-width="180px"></el-form-item>
            <el-form-item v-if="singVerifyForm.authWaysValue=='pin'">
              <el-input :type="showPasswordType"  placeholder="请输入签署密码" maxlength="6"  v-model.trim="singVerifyForm.pin"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              <div class="code-icon">
                <img v-show="isShowPassword" class="icon" src="@/assets/images/unifysign/eye.png" alt="" @click="isShowPassword=false">
                <img v-show="!isShowPassword" class="icon-noeye" src="@/assets/images/unifysign/noeye.png" alt=""  @click="isShowPassword=true">
              </div>
              <div v-show="pinAlert" class="alert">{{pinAlertMsg}}</div>
            </el-form-item>

            <el-form-item v-if="singVerifyForm.authWaysValue=='live'" style="text-align: center">
              <div class="qrcode-box">
              <img class="code-img" :src="qrcodeUrl" alt="">
                <div v-if="qrCodeStatus=='scanned'" class="mask success">
                  <img class="icon" src="@/assets/images/unifysign/check-circle.png" alt="">
                  <span class="txt">已扫码</span>
                </div>

                <div v-if="qrCodeStatus=='expired'" class="mask warning">
                  <img class="icon" src="@/assets/images/unifysign/exclamation-circle.png" alt="">
                  <span class="txt">二维码已失效</span>
                </div>

                <div v-if="qrCodeStatus=='notPass'" class="mask danger">
                  <img class="icon" src="@/assets/images/unifysign/x-circle.png" alt="">
                  <span class="txt">验证未通过请重新验证</span>
                </div>
              </div>
              <div style="margin-top: 25px">
                <p style="padding-bottom: 25px">请<span style="color: #3F7BF9">{{singVerifyForm.signerName}}</span>本人使用微信扫描二维码进行人脸识别验证</p>
                <el-button style="margin-bottom: 10px" size="small"  class="" type="primary" @click="getFaceAuthLinkStillApi('refresh')">刷新二维码</el-button>
              </div>


            </el-form-item>
            <el-form-item v-if="singVerifyForm.authWaysValue=='sms' " style="text-align: center">
              <el-button  :disabled="!singVerifyForm.vcode" class="signVerifySubmitBtn" type="primary" @click="singVerifyFormSubmit(singVerifyForm.authWaysValue)">确认</el-button>
            </el-form-item>
              <el-form-item v-if="singVerifyForm.authWaysValue=='pin'" style="text-align: center">
              <el-button :disabled="!singVerifyForm.pin"  class="signVerifySubmitBtn" type="primary" @click="singVerifyFormSubmit(singVerifyForm.authWaysValue)">确认</el-button>
            </el-form-item>
            </template>
            <div class="wancheng" v-if="signStatusDialog=='finish'">
              <img src="@/assets/images/unifysign/wancheng.png" alt="">
              <div class="txt">
                签署已完成
              </div>
              <div>
                <el-button  v-if="singVerifyForm && singVerifyForm.returnUrl"  class="fanhui" type="primary"  @click="handleBackHome">返回</el-button>
              </div>
            </div>
            <div class="wancheng" v-if="signStatusDialog=='expire'">
              <img src="@/assets/images/unifysign/guoqi.png" alt="">
              <div class="txt">
                签署已过期
              </div>
              <div>
                <el-button v-if="singVerifyForm && singVerifyForm.returnUrl"  class="fanhui" type="primary" @click="handleBackHome">返回</el-button>
              </div>
            </div>
          </el-form>
        </div>
        <div v-if="!singVerifySuccess" class="signVerify-footer">
          <img class="dunpai" src="@/assets/images/sign/zhuangshi.png" alt="">
        </div>
        <div v-if="singVerifySuccess" class="singVerify-success">
          <img src="@/assets/images/unifysign/singVerify-success.png" alt="">
          <p class="p1">验证通过，即将进入签署页面</p>
          <p class="p2">{{singVerifySuccess_time}}s</p>

        </div>
      </div>
      <div v-if="sidExpired" class="sidExpired">
        <img src="@/assets/images/unifysign/guoqi.png" alt="">
        <div class="txt">
          签署页面已失效
        </div>

      </div>
    </div>
	  <div v-show="signLayer" id="sign-layer" v-loading="saveLoading">
     <div class="title-top flex-center auto">
       <div class="flex-center">
         <div class="flex-center title-left">
           <svg-icon icon-class="cross-close" style="cursor: pointer;" width="30" height="30"
                     @click="closeTitleTop" v-if="singVerifyForm && singVerifyForm.returnUrl"></svg-icon>
           <div class="title">合同签署</div>
         </div>
         <div class="center-title">
           {{ taskName }}
         </div>
         <div class="qianshuzhuangtai" v-if="qianshuzhuangtai">
           <img src="@/assets/images/unifysign/qswc.png" alt="">
           <span class="txt">签署完成</span>
         </div>
       </div>

       <div class="flex-center">
         <el-button v-if="!qianshuzhuangtai" type="primary" size="small" style="margin-left: 20px;" @click="hanleSaveFun">确认签署</el-button>
         <el-button v-if="qianshuzhuangtai && singVerifyForm && singVerifyForm.returnUrl" type="primary" size="small" style="margin-left: 20px;" @click="handleBackHome">退出</el-button>
       </div>
     </div>
		<div class="setcontrol-content auto" id="main">
			<div class="set-sign-control" id="set-sign">
        <div class="sign-guide">
          <div class="guide-head flex-center">
            <svg-icon iconClass="icon-warning" width="16" height="16" style="margin-right: 8px;"></svg-icon>
            操作指引
          </div>
          <div class="guide-content">
            鼠标拖拽下方签署方印章控件到中间合同文件页中，松开鼠标完成...
            <el-popover placement="bottom" title="操作指引" width="245" trigger="hover" content="">
              <div>
                1、将左侧栏【企业章】【法定代表人章】【人名章】【日期章】拖入中间栏文档中要盖章的位置即可完成一处盖章。
              </div>
              <div>
                2、重复步骤1可对多文件多位置盖章，已拖拽到文档中的印章可再次拖拽调整位置，也可点击印章右上角"X"进行删除。
              </div>
              <div>
                3、设置完所有盖章位置后，击【确认签署】根据提示完成后续流程。
              </div>
              <div>
                注：企业签署方【企业章】必须加盖，其他类型章为可选项；个人签署方【人名章】必须加盖，其他类型章为可选项。
              </div>
              <div
                style="color: #303133;font-size: 16px;line-height: 1;margin-top: 14px;margin-bottom: 14px;">
                二、点击图片查看详细操作截图
              </div>
              <div clss="demo-image__preview">
<!--								<el-image :src="howToTipSrc" :preview-src-list="[howToTipSrc]"></el-image>-->
                <el-image :src="require('@/assets/images/unifysign/signHelp.png')" :preview-src-list="[require('@/assets/images/unifysign/signHelp.png')]"></el-image>
              </div>
              <span slot="reference" class="guide-detail" style="cursor: help;">详情</span>
            </el-popover>

          </div>
          <div class="magic-btn-wrap" v-if="positonExistFlag" >
            <el-button class="magic-btn" @click="handleAutoSeal" :disabled="signStatus != 'iSign' || saveLoading">
              <svg-icon icon-class="icon-seal-white" width="12.5" height="14"
                        style="margin-right: 12px;"></svg-icon>一键盖章
            </el-button>
          </div>
        </div>
				<div class="seal-list-wrap" style="overflow: auto;transition:height .3s ease-in-out">
					<div v-for="(sealGroupItem, key) in sealInfoArrayMap" :key="key">
            <div class="group-item-title">
              <svg-icon iconClass="bar" width="2" height="12" style="margin-right: 8px;"></svg-icon>
              <span v-if="key == 'companyCommon'">企业章</span>
              <span v-if="key == 'person'">个人签名</span>
              <span v-if="key == 'companyLegal'">法定代表人章</span>
              <span v-if="key == 'companyAgent'">经办人签名</span>
              <span v-if="key == 'date'">日期章</span>
            </div>
            <div class="qifengzhang" v-if="!positonExistFlag && key == 'companyCommon'">
              <span>
                <span style="margin-right: 8px;font-size: 14px" placement="bottom-end">骑缝章</span>
                 <el-popover
                     placement="bottom-start"
                     width="200"
                     trigger="hover"
                     content="打开骑缝章开关后，拖拽到文档中的【企业章】将自动在文档所有页右侧加盖骑缝章。">
                   <i slot="reference" class="el-icon-warning-outline" style="font-size: 14px;color: #A6ACB4"></i>
                </el-popover>
              </span>
              <el-switch
                  v-model="isPaging"
                  active-color="#3F7BF9"
                  inactive-color="#ECEFF3"
                  style="zoom:0.8;"
              >
              </el-switch>
            </div>
            <div v-for="(item, usrIdx) in sealGroupItem" :key="usrIdx">
						<div class="select-sign" :data-seal-type="key" >
               <span v-if="key !== 'date'">
									<span class="tag process" v-if="item.permissionType == 'process'">需审批</span>
									<span class="tag authed" v-if="item.permissionType == 'authed'">已授权</span>
									<span class="tag forbid" v-if="item.permissionType == 'disabled'">不可用</span>
								</span>
              <span>
                <img v-if="isPaging && item.sealType=='companyCommon'" class="qifeng" src="@/assets/images/unifysign/qifeng.png" alt="">
              </span>
              <div class="sign-item">
                <div class="sign-img-box drag-box sign-box" data-type="sign"
                     :data-seal-type="item.sealType" :data-sign-id="item.sealId"
                     :data-seal-id="item.sealId" :data-permission-type="item.permissionType"
                     :data-seal-name="item.sealName" v-drop>
                  <img :src="item.sealImg" alt="" ondragstart="return false" />
                </div>
              </div>
						</div>
            <div class="seal-name">{{ item.sealName }}</div>
            </div>
					</div>

				</div>
				<!--  -->
				<div v-if="needHandwritten == 'yes'">
					<div class="set-title">
						<span>制作签名</span>
					</div>
					<div class="select-sign">
						<div class="sign-list">
							<div class="sign-item">
								<div class="handwrite-img-wrap">
									<div class="drag-box sign-box" v-drop v-if="customHandwriteImg" data-type="sign"
										data-seal-type="person" :data-seal-id="customHandwriteSealId">
										<img :src="customHandwriteImg" alt="" ondragstart="return false">
									</div>
									<el-button icon="el-icon-delete" type="danger" plain circle
										@click="confirmDeleteHandwrite" v-if="customHandwriteImg"></el-button>
									<el-button icon="el-icon-plus" circle @click="handleNewHandWrite" v-else>
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>


<!--				<div style="position: sticky;bottom: 0;left: 0;width: 100%;    background: #fff;" v-if="!positonExistFlag"-->
<!--					v-show="signFileInfoArray[active] && signFileInfoArray[active].fileImgArray.length != 0">-->
<!--					&lt;!&ndash; <div class="pages-head">-->
<!--						<span class="big">骑缝章</span>-->
<!--						<span class="sub"></span>-->
<!--					</div> &ndash;&gt;-->

<!--					<div class="pages-head">-->
<!--						<span class="big"><el-checkbox v-model="isPaging"-->
<!--								style="font-weight: bold;    font-size: 16px;    color: #333333;">骑缝章</el-checkbox></span>-->
<!--						<span class="sub"> <el-popover placement="right-start" title="提示" width="300" trigger="hover">-->
<!--								<div>-->
<!--									勾选骑缝章后，将左侧栏印章拖入中间栏文档中，系统将自动对文档全部页添加骑缝样式的印章。-->
<!--								</div>-->

<!--								<div slot="reference" style="color: #E6A23C;cursor: help;"><i class="el-icon-info"></i>-->
<!--								</div>-->

<!--							</el-popover></span>-->
<!--					</div>-->
<!--					&lt;!&ndash; <div class="set-title-padding">-->
<!--							<el-checkbox v-model="isPaging">骑缝章</el-checkbox>-->
<!--						</div>-->
<!--						<div class="set-title-padding" style="font-size: 13px;    color: #606266;">-->
<!--							提示：勾选骑缝章复选框后，将左侧栏印章拖入中间栏文档中要盖章的位置，印章将自动定位到文档右侧贴边展示。-->
<!--						</div> &ndash;&gt;-->


<!--				</div>-->


			</div>
			<!-- 滑动容器 -->
      <div class="tabTitle-box" id="tabTitleBox">
        <div class="tabTitle" ref="scrollContainer">
          <div :class="{ active: idx == active }" class="item" :key="idx" v-for="(item, idx) in signFileInfoArray" @click="tabTitleChange(idx)">
            <img v-if="idx == active" src="@/assets/images/unifysign/wenjianactive.png" alt="">
            <img v-else src="@/assets/images/unifysign/wenjian.png" alt="">
            <span class="txt">{{item.fileName}}</span>
          </div>
        </div>

        <div class="contract-container" >
			  <div class="contract-content" ref="cmain">
				<div class="contract-img-content">
					<div class="contract-imgs" id="contract-imgs" ref="contract">
						<div v-for="(item, idx) in signFileInfoArray" :key="idx" v-show="idx == active" class="file-item">
              <div class="img-wrap" v-for="(contract, index) in item.fileImgArray" :key="index"
                   ref="imgWrap">
                <img :src="contract.src" class="contract-img" alt="" ondragstart="return false" />
                <div v-show="renderOK" v-for="(pos, posIdx) in contract.poss"
                     :key="pos.positionId + posIdx" class="position-box" :data-pos-id="pos.positionId"
                     :data-seal-type="pos.sealType" :data-type="pos.sealLocationType" :style="{
											left:
												pos.sealLocationType == 'paging'
													? 'unset'
													: (pos.positionX / 50000).toFixed(4) * 100 + '%',
											top: (pos.positionY / 50000).toFixed(4) * 100 + '%',
											right: pos.sealLocationType == 'paging' ? '0' : 'unset',
										}" :tabIndex="posIdx">
                  <div v-if="pos.sealType == 'companyCommon' &&
											pos.sealLocationType == 'position'
											" class="seal-pos-box">
                    <div class="box-head">
                      <svg-icon iconClass="seal-fill-company" width="20" height="20"></svg-icon>
                      <span title="企业章">企业章</span>
                    </div>
                    <div class="seal-name"></div>
                    <i class="el-icon-close" @click="handleDeleteInnerSeal(pos, $event)"></i>
                  </div>
                  <div v-if="pos.sealType == 'companyLegal' &&
											pos.sealLocationType == 'position'
											" class="sign-pos-box">
                    <div class="box-head">
                      <svg-icon iconClass="seal-fill-legal" width="20" height="20"></svg-icon>
                      <span title="法定代表人章">法定代表人章</span>
                    </div>
                    <div class="seal-name"></div>
                    <i class="el-icon-close" @click="handleDeleteInnerSeal(pos, $event)"></i>
                  </div>
                  <div v-if="pos.sealType == 'companyAgent' &&
											pos.sealLocationType == 'position'
											" class="sign-pos-box">
                    <div class="box-head">
                      <svg-icon iconClass="seal-fill-sign" width="20" height="20"></svg-icon>
                      <span title="经办人签名">经办人签名</span>
                    </div>
                    <div class="seal-name"></div>
                    <i class="el-icon-close" @click="handleDeleteInnerSeal(pos, $event)"></i>
                  </div>
                  <div v-if="pos.sealType == 'person' &&
											pos.sealLocationType == 'position'
											" class="sign-pos-box">
                    <div class="box-head">
                      <svg-icon iconClass="seal-fill-sign" width="20" height="20"></svg-icon>
                      <span title="个人签名">个人签名</span>
                    </div>
                    <div class="seal-name"></div>
                    <i class="el-icon-close" @click="handleDeleteInnerSeal(pos, $event)"></i>
                  </div>
                  <div v-if="pos.sealType == 'date' &&
											pos.sealLocationType == 'position'
											" class="date-pos-box">
                    <div class="box-head">
                      <svg-icon iconClass="seal-fill-date" width="20" height="20"></svg-icon>
                      <span title="日期章">日期章</span>
                    </div>
                    <div class="seal-name"></div>
                    <i class="el-icon-close" @click="handleDeleteInnerSeal(pos, $event)"></i>
                  </div>
                  <div v-if="pos.sealLocationType == 'paging'" class="paging-pos-box">
                    <div class="box-head">
                      <svg-icon iconClass="seal-fill-paging" width="20" height="20"></svg-icon>
                      <span title="企业骑缝章">企业骑缝章</span>
                    </div>
                    <div class="seal-name"></div>
                    <i class="el-icon-close" @click="handleDeleteInnerSeal(pos, $event)"></i>
                  </div>
                </div>
              </div>
						</div>
					</div>
				</div>
			</div>
        <div class="page-indicator" v-if="signFileInfoArray[active]" v-show="signFileInfoArray[active].filePages > 1">
          <div class="page-icon" @click="handlePageUp" v-show="signFileInfoArray[active].current != 0">
            <svg-icon class="page-icon-inner" iconClass="page-up" width="16" height="16"></svg-icon>
            <svg-icon class="page-icon-inner active" iconClass="page-up-active" width="16" height="16"></svg-icon>
          </div>
          <div class="page-icon" @click="handlePageDown"
               v-show="signFileInfoArray[active].current != signFileInfoArray[active].fileImgArray.length - 1">
            <svg-icon class="page-icon-inner" iconClass="page-down" width="16" height="16"></svg-icon>
            <svg-icon class="page-icon-inner active" iconClass="page-down-active" width="16" height="16"></svg-icon>
          </div>
        </div>


        <el-popover placement="bottom-end" width="180" trigger="hover" popper-class="light-popper"
                    v-if="countPositionSealList[active] && showLocatePopover && notSealCount && positonExistFlag">
          <p>共有{{ notSealCount }}个待签署未处理，点击快速定位</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="showLocatePopoverFalse">不再提示</el-button>
          </div>
          <div class="locate-indicator" slot="reference" @click="handleQuickLocateNotSeal">
            <div class="locate-icon">
              <svg-icon class="locate-icon-inner" iconClass="locate" width="22" height="22"></svg-icon>
              <svg-icon class="locate-icon-inner active" iconClass="locate-active" width="22"
                        height="22"></svg-icon>
            </div>
            <span class="badge" v-if="countPositionSealList[active] && notSealCount">{{ notSealCount }}</span>
          </div>
        </el-popover>
<!--          未指定签署位置的时候-->
          <el-popover placement="bottom-end" width="180" trigger="hover" popper-class="light-popper"
                      v-if="!positonExistFlag && showLocatePopoverNew">
            <p>共签署{{ sealCount }}个章，点击快速定位</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="showLocatePopoverTrue">不再提示</el-button>
            </div>
            <div class="locate-indicator" id="locateIndicator" slot="reference" @click="handleQuickLocateSeal">
              <div class="locate-icon">
                <svg-icon class="locate-icon-inner" iconClass="locate" width="22" height="22"></svg-icon>
                <svg-icon class="locate-icon-inner active" iconClass="locate-active" width="22"
                          height="22"></svg-icon>
              </div>
              <span class="badge" v-if="sealCount">{{ sealCount }}</span>
            </div>
          </el-popover>

<!--        <div class="locate-indicator" v-else @click="handleQuickLocateNotSeal">-->
<!--          <div class="locate-icon">-->
<!--            <svg-icon class="locate-icon-inner" iconClass="locate" width="22" height="22"></svg-icon>-->
<!--            <svg-icon class="locate-icon-inner active" iconClass="locate-active" width="22"-->
<!--                      height="22"></svg-icon>-->
<!--          </div>-->
<!--          <span class="badge" v-if="countPositionSealList[active] && notSealCount">{{ notSealCount }}</span>-->
<!--        </div>-->
      </div>
      </div>
			<div class="contract-page">
				<div class="pages-head">
					<span class="big">文件列表</span>
					<span class="sub">共{{ signFileInfoArray.length }}份</span>
				</div>
				<el-collapse v-model="active" accordion @change="changeCollapse">
					<el-collapse-item :title="item.fileName" :name="idx" v-for="(item, idx) in signFileInfoArray"
						:key="idx">
						<div v-for="(img, imgIdx) in item.fileImgArray" :key="imgIdx" class="page-wrap">
							<img :src="img.src" alt="" ondragstart="return false"
								:class="{ current: item.current == imgIdx }" @click="handleChangeContractImg(imgIdx,null,item.signFileId)" />
							<div class="page" :class="{ current: item.current == imgIdx }">
								{{ imgIdx + 1 + "/" + item.fileImgArray.length }}
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- <div class="all-page">
					<div class="page-item" v-for="(contract, index) in contractImgs" :key="index">
						<div class="page-img" @click="jumpPage(index)">
							<img :src="contract.src" alt="">
							<img v-if="contract.isSign" :src="iconImgs[parseInt(contract.isSign)-1]" class="sign-icon" alt="">
						</div>
						<p class="page-text">第{{index+1}}页</p>
					</div>
				</div> -->
			</div>
		</div>
<!--		<div class="submit-btn clearfix" v-show="contractImgs.length > 0">-->
<!--			&lt;!&ndash; <el-button type="primary" class="submit" @click="returnHandle">退回</el-button> &ndash;&gt;-->
<!--			<el-button type="primary" class="submit" :disabled="signStatus != 'iSign' || saveLoading" @click="handleSave"-->
<!--				v-if="(signStatus != 'finish') && (saveLoading || !signSucceed)">确认签署</el-button>-->
<!--			<el-button v-else-if="signFinishLoading" :disabled="true"-->
<!--				style="color: #3296FA;border-color: #c2e0fe;background-color: #ebf5ff;">已完成签署（{{ countDownSecond-->
<!--				}}）秒后自动返回</el-button>-->
<!--			<el-button type="primary" class="submit" :disabled="true" v-else>已完成签署</el-button>-->
<!--		</div>-->

		<sign-auth ref="auth" :sid="sid" @getAuthCode="getAuthCodeHandle"></sign-auth>

		<el-dialog :close-on-click-modal="false" :append-to-body="true" class="apply-dialog" title="发起用章申请"
			:visible.sync="applyOpen" width="520px" :center="true">
			<div class="main-apply" style="color: #333">
				<div v-for="(item, idx) in applyData" :key="idx">
					<div style="margin: 0 4px 20px; color: #333">
						{{ idx + 1 }}. 您指定的企业印章《{{
							item.sealName
						}}》未经过授权，如要使用将发起用章审批流程
					</div>
					<el-descriptions title="" :column="1" border style="margin: 0 4px 20px; color: #333">
						<el-descriptions-item label="审批名称" :labelStyle="{ color: '#333', width: '107px' }">{{
							item.flowName
						}}
						</el-descriptions-item>
						<el-descriptions-item label="审批描述" :labelStyle="{ color: '#333', width: '107px' }">{{
							item.flowDesc
						}}
						</el-descriptions-item>
						<el-descriptions-item label="审批节点数量" :labelStyle="{ color: '#333', width: '107px' }">{{
							item.nodeNum
						}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<div style="margin: 0 4px; color: #333">请填写：</div>
				<div class="apply-pane" style="margin-top: 8px">
					<div class="apply-pane-item">
						<el-form @submit.native.prevent :model="applyForm" :rules="applyFormRules" ref="applyForm"
							class="apply-Form">
							<el-form-item label="流程名称" prop="processName" label-width="107px">
								<el-input placeholder="请输入流程名称" v-model="applyForm.processName" maxlength="20">
								</el-input>
							</el-form-item>
							<el-form-item label="流程描述" prop="processDesc" label-width="107px">
								<el-input placeholder="请输入流程描述" v-model="applyForm.processDesc" maxlength="20">
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div style="margin: 0 4px 30px; color: #333">
					流程发起成功后，可到企业控制台查看您发起的审批流程详情
				</div>
				<div class="dialog-btns" style="padding: 0 4px">
					<el-button type="primary" style="padding: 13px 50px" @click="submitApplyHandle" class="btn-ok">继续
					</el-button>
					<el-button type="info" style="float: right; padding: 13px 50px" @click="cancelApply"
						class="btn-cancel">取消
					</el-button>
				</div>
			</div>
		</el-dialog>


		<el-dialog title="手写签名" :visible.sync="handWriteDialogVisible" :close-on-click-modal="false" :append-to-body="true"
			width="400px" custom-class="handwrite-dialog">
			<div id="draw-seal">
				<!-- <div class="tip-success" id="tip-success">绘制成功</div>
				<div class="tip-waning" id="tip-waning"></div> -->
				<div id="seal-main">
					<canvas id="seal-canvas"></canvas>
					<div class="draw-tip">
						<img src="@/assets/images/draw-icon.png" alt="" ondragstart="return false">
						<p>绘制签名</p>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="clearSign">清 除</el-button>
				<el-button type="primary" @click="drawSign">确 定</el-button>
			</span>
		</el-dialog>

<!--		<el-dialog title="选择盖章" :visible.sync="autoSealDialogVisible" :close-on-click-modal="false" :append-to-body="true"-->
<!--			width="700px" custom-class="autoseal-dialog">-->

<!--			<div class="auto-seal-wrap">-->
<!--				<div v-for="(arr, key) in sealInfoArrayMapAutoSeal" :key="key">-->
<!--					<div class="set-title">-->
<!--						<span v-if="key == 'companyCommon'">企业章</span>-->
<!--						<span v-if="key == 'companyLegal'">法定代表人章</span>-->
<!--						<span v-if="key == 'date'">日期</span>-->
<!--					</div>-->


<!--					<div class="auto-seal-list">-->
<!--						<div v-for="item in arr" :key="item.sealId" class="auto-seal-item"-->
<!--							@click="handleSelectAutoSeal(item, arr)" :class="{ 'isCheck': item.check }">-->
<!--							<div>-->
<!--								<div data-type="sign" :data-seal-type="item.sealType" :data-seal-id="item.sealId">-->
<!--									<img :src="item.sealImg" alt="" ondragstart="return false" />-->
<!--								</div>-->
<!--								<i class="el-icon-success" v-if="item.check"></i>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->

<!--			</div>-->



<!--			<span slot="footer" class="dialog-footer">-->
<!--				<el-button @click="autoSealDialogVisible = false">取 消</el-button>-->
<!--				<el-button type="primary" @click="handleCheckAutoSeal">确 定</el-button>-->
<!--			</span>-->
<!--		</el-dialog>-->

     <el-drawer title="选择盖章" :visible.sync="autoSealDrawer" direction="ltr" append-to-body :show-close="true"
                :modal="true" :withHeader="true" size="500px" custom-class="auto-seal-drawer">
       <div class="auto-seal-wrap">
         <div v-for="(arr, key) in sealInfoArrayMapAutoSeal" :key="key">

           <div class="set-title-drawer">
             <svg-icon iconClass="bar" width="2" height="12" style="margin-right: 8px;"></svg-icon>
             <span v-if="key == 'companyCommon'">企业章</span>
             <span v-if="key == 'person'">个人签名</span>
             <span v-if="key == 'companyLegal'">法定代表人章</span>
             <span v-if="key == 'companyAgent'">经办人签名</span>
             <span v-if="key == 'date'">日期章</span>
           </div>

           <div class="auto-seal-list">
             <div v-for="item in arr" :key="item.sealId" class="auto-seal-item-draw"
                  @click="handleSelectAutoSeal(item, arr)">
               <div class="select-sign-draw" :data-seal-type="key" :class="{ 'isCheck': item.check }">
								<span v-if="key !== 'date'">
									<span class="tag process" v-if="item.permissionType == 'process'">需审批</span>
									<span class="tag authed" v-if="item.permissionType == 'authed'">已授权</span>
									<span class="tag forbid" v-if="item.permissionType == 'disabled'">不可用</span>
								</span>
                 <div class="sign-item-draw" data-type="sign" :data-seal-type="item.sealType"
                      :data-seal-id="item.sealId">
                   <img :src="item.sealImg" alt="" ondragstart="return false" />
                 </div>
                 <i class="check-fill" v-if="item.check">
                   <svg-icon iconClass="tick" width="10" height="7.42"></svg-icon>
                 </i>
                 <i class="check-circle" v-else="item.check"></i>
               </div>
               <div class="seal-name">{{ item.sealName }}</div>
             </div>
           </div>
         </div>

       </div>
       <div class="drawer-footer">
         <div>已选{{ checkedAutoSealLength }}项</div>
         <div class="flex-center">
           <el-button size="small" class="grey-btn" @click="autoSealDrawer = false">取消</el-button>
           <el-button type="primary" size="small" style="margin-left: 16px;"
                      @click="handleCheckAutoSeal">确定</el-button>
         </div>
       </div>
     </el-drawer>
<!--确认签署时的验证弹窗-->
     <el-dialog
         title="提示"
         :visible.sync="handleSaveDialogVisible"
         width="30%"
         append-to-body
     >
       <div slot="title" style="font-size: 16px;display: flex;justify-content: left">
         <img  style="margin-right: 8px;width: 21px;height: 21px" src="@/assets/images/unifysign/union.png" alt="">
         <span>温馨提示</span>
       </div>
<!--       <span>《xxxx文件》的第2页、第3页，《xxxx文件》的第3页、第4页还没有盖章，请盖章后再次确认签署</span>-->
       <span>{{handleSaveDialogMsg}}</span>
       <div slot="footer" style="text-align: right">
        <el-button type="primary" size="small" @click="handleSaveDialogVisible = false" style="font-weight: normal">继续盖章</el-button>
      </div>
     </el-dialog>

<!--   签署意愿验证弹窗  -->
     <el-dialog
         class="authMethodType"
         title="签署意愿验证"
         :visible.sync="authMethodTypeVisible"
         width="35%"
         append-to-body
         :close-on-click-modal="false"
     >
       <div>
         <el-form label-position="left">
           <template v-for="(item,index) in singVerifyForm.authWaysArr" >
               <template v-if="authMethodType=='sms' && item.label=='sms'">
               <el-form-item label="验证码将发送至您的手机：" label-width="180px">
                 {{singVerifyForm.phone}}
               </el-form-item>
               <el-form-item>
                 <el-input  placeholder="输入验证码" maxlength="6" v-model.trim="singVerifyForm.vcode" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                 <div class="code-btn">
                   <el-button class="right-btn"  type="primary" plain :disabled="!sendCode"
                              @click="getMsgAuthCode" v-show="sendCode">获取验证码</el-button>
                   <el-button type="primary" plain v-show="!sendCode" class="right-btn">
                     重新获取({{ auth_time }})秒</el-button>
                 </div>
                 <div v-show="sendCodeAlert" class="alert">{{sendCodeAlertMsg}}</div>
               </el-form-item>
               </template>
               <template v-if="authMethodType=='pin' && item.label=='pin'">
               <el-form-item  label="请输入签署密码" label-width="180px"></el-form-item>
               <el-form-item >
                 <el-input :type="showPasswordType" maxlength="6"  placeholder="请输入签署密码" v-model.trim="singVerifyForm.pin"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                 <div class="code-icon">
                   <img v-show="isShowPassword" class="icon" src="@/assets/images/unifysign/eye.png" alt="" @click="isShowPassword=false">
                   <img v-show="!isShowPassword" class="icon-noeye" src="@/assets/images/unifysign/noeye.png" alt=""  @click="isShowPassword=true">
                 </div>
                 <div v-show="pinAlert" class="alert">{{pinAlertMsg}}</div>
               </el-form-item>
               </template>
               <template v-if="authMethodType=='live' && item.label=='live'">
                <el-form-item  style="text-align: center">
                 <p style="padding-bottom: 10px">
                   请使用微信扫描二维码进行人脸识别验证
                 </p>
                 <div class="qrcode-box">
                   <img class="code-img" :src="qrcodeUrl" alt="">

                   <div v-if="qrCodeStatus=='scanned'" class="mask success">
                     <img class="icon" src="@/assets/images/unifysign/check-circle.png" alt="">
                     <span class="txt">已扫码</span>
                   </div>

                   <div v-if="qrCodeStatus=='expired'" class="mask warning">
                     <img class="icon" src="@/assets/images/unifysign/exclamation-circle.png" alt="">
                     <span class="txt">二维码已失效</span>
                   </div>

                   <div  v-if="qrCodeStatus=='notPass'" class="mask danger">
                     <img class="icon" src="@/assets/images/unifysign/x-circle.png" alt="">
                     <span class="txt">验证未通过请重新验证</span>
                   </div>
                 </div>
                 <div style="margin-top: 25px">
                   <div class="shuaxin" @click="getFaceAuthLinkStillApi('refresh')">刷新<i class="el-icon-refresh-right"></i></div>
                 </div>


               </el-form-item>
               </template>
           </template>

         </el-form>
       </div>
       <div slot="footer" class="authMethodType_footer">
         <div class="btns" v-if="authMethodType=='sms'">
         <el-button size="medium" @click="authMethodTypeVisible = false" style="color: #000;font-weight: normal;width: 100px;background-color: #F1F1F1;border: none">取消</el-button>
         <el-button type="primary" :disabled="!singVerifyForm.vcode" size="medium" @click="singVerifyFormSubmitAfter(authMethodType)" style="font-weight: normal;width: 100px">确认</el-button>
         </div>
         <div class="btns" v-if="authMethodType=='pin'">
           <el-button size="medium" @click="authMethodTypeVisible = false" style="color: #000;font-weight: normal;width: 100px;background-color: #F1F1F1;border: none">取消</el-button>
           <el-button type="primary" :disabled="!singVerifyForm.pin" size="medium" @click="singVerifyFormSubmitAfter(authMethodType)" style="font-weight: normal;width: 100px">确认</el-button>
         </div>
         <div class="otherAuthType" v-if="singVerifyForm.authWaysArr && singVerifyForm.authWaysArr.length>1">
           <span  style="font-size: 14px;color: #86909C;padding-right: 20px">其他验证方式:</span>
           <span  v-for="(item,index) in singVerifyForm.authWaysArr" :key="index">
           <span v-if="authMethodType!='sms' && item.label=='sms'" @click="authMethodTypeFun(item.label)">
              <img  class="img" src="@/assets/images/unifysign/duanxin.png" alt="">
              <span class="txt">短信验证</span>
           </span>
           <span v-if="authMethodType!='pin'  && item.label=='pin'" @click="authMethodTypeFun(item.label)">
              <img  class="img" src="@/assets/images/unifysign/suo.png" alt="">
              <span  class="txt">签署密码验证</span>
           </span>
           <span v-if="authMethodType!='live'  && item.label=='live'" @click="authMethodTypeFun(item.label)">
              <img  class="img" src="@/assets/images/unifysign/shualian.png" alt="">
               <span  class="txt">刷脸验证</span>
           </span>
           </span>
         </div>
       </div>
     </el-dialog>
	</div>
  </div>
</template>
<script>
// 新增功能点：多文件支持，同文件不同图片间任意拖拽，拖拽位置自动判定
// 企业权限鉴定并新添审批机制
import { Loading } from "element-ui";
import signAuth from "./sign-auth";
import lightHeader from "@/components/lightHeader";


import { getSignInfoPcAndH5, signPcAndH5, checkHandwrite,getTaskInfo } from "@/api/unifysign/sign";
import {
  getSignDetailInfo,
  taskSign,
  checkSealPermission,
  signWithProcess,
  saveLocation,
  getContractPositionApi,
  signSealApi,
  returnContractApi,
  autoLoginByTokenApi,
  getDatePngSrcApi,
  getCompanyLegalApi,
  getSealListApi,
  getContractApi,
  signSealOpenApi, listProcess,
  getSmsVerificationCode,
  getAuthTokenBySmsVerificationCodeOpen,
  getAuthTokenByPinOpen,
  getFaceAuthLinkStill,
  getFaceAuthResult
} from "@/api/sign/sign";
import {getUserSealInfoApi, keepAskingHandwrite} from "@/api/common";
import { getCompanySealInfoApi } from "@/api/space/signatures";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { mapState } from "vuex";
import {getStyle} from "@/utils/animte";
export default {
	components: {
		lightHeader,
		signAuth,
	},
	data() {
		return {
      items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6", "Item 7", "Item 8", "Item 9", "Item 10"],
      lastX: 0,
      timer: null,
      dialogVisible:false,
      authMethodTypeVisible:false,
      taskName: "",
      singVerifyForm:{
        vcode:'',//短信验证码
        pin:'',//签署密码

      },//认证前后 弹窗内容
      sendCode:true, //
      sendCodeAlert:false,
      sendCodeAlertMsg:"",
      pinAlert:false,
      pinAlertMsg:"", //提示信息
      qrcodeUrl:'',//刷脸二维码
      qrCodeStatus:'',//二维码状态
      authId:'',//刷脸二维码 认证ID
      getFaceAuthResultTimer:undefined,
      auth_time: 60,
      isShowPassword:false,//显示隐藏密码框
      singVerifySuccess:false,//是否验证通过
      singVerifySuccess_time:2, //验证通过倒计时
      signLayer:true,
      authMethodType:'sms',//签署后的验证弹窗  sms 短信验证  pin 签署密码验证 live 刷脸验证
			sid: "",
			signFileInfoArray: [],
			sealInfoArray: [],
      sealInfoArrayMap: [],
			active: 0,
			scrollWatchStatus: true, //点击右侧缩略图时，暂时停止监听页面滚动
			judgeScope: 40,
			positionSealArray: [],
			showTip: true,
			showCustom: false,
			contractH: null,
			setContractH: null,
			// contractImgs: [],
			selectId: "",
			signImgs: [],

			stitle: " ",
			isTime: "0",
			scrollTop: 0,
			signatoryId: 456,
			renderOK: false,
			positionList: [],
			sealList: [],
			code: "",
			pin: "",
			approvalNum: 0,
			hrefFrom: this.$route.query.hrefFrom,
			dateList: [],
			dateSrc: "",
			lastActive: "",
			saveLoading: false,
			applyOpen: false,
			applyForm: {
				processName: "",
				processDesc: "",
			},
			applyFormRules: {
				processName: [
					{
						required: true,
						message: "请输入流程名称",
						trigger: "change",
					},
				],
				processDesc: [
					{
						required: true,
						message: "请输入流程描述",
						trigger: "change",
					},
				],
			},
			applyData: null,

			pagingId: 0, // 骑缝章id

			positonExistFlag: undefined,
			signSucceed: false,

			handWriteDialogVisible: false,
			customHandwriteImg: "",
			customHandwriteSealId: "",
			needHandwritten: "no",
			signStatus: undefined,
      signStatusDialog: undefined,

			autoSealDialogVisible: false,

			sealInfoArrayMapAutoSeal: {},
			isPaging: false,

      countPositionSealList: [], // 落章统计
      showLocatePopover: true,
      locatePositionBoxByStepIdx: -1, // 初始值是-1 因为每点一次会自增
      sealCount:0,//未定位时已拖章的数量
      showLocatePopoverNew:true,
      locateNotPositionBoxByStepIdx:-1,

			helpActive: [],

			// howToTipSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/signHelp.png",
			howToTipSrc: "@/assets/images/unifysign/signHelp.png",
			countDownSecond: 5,
			signFinishLoading: false,

      autoSealDrawer: false,
      checkedAutoSealLength: 0,
      authStep:undefined,//认证时机：签署前：before签署时：after 不认证：not
      handleSaveDialogVisible:false,
      handleSaveDialogMsg:"",
      qianshuzhuangtai:false,
      sidExpired:false,




		}
	},
	computed: {
		...mapState(["companyList", "currentSpace"]),
    contractImgs() {
      if (this.signFileInfoArray[this.active]) {
        return this.signFileInfoArray[this.active].fileImgArray;
      } else {
        return [];
      }
    },
    notSealCount() {
      if (this.countPositionSealList[this.active]) {
        return this.countPositionSealList[this.active].filter(_ => {
          return !_.sealId
        }).length;
      } else {
        return ""
      }

    },
    //未指定盖章位置  已经拖动章的数量
    // sealCount() {
    //   console.log(this.countPositionSealListNew.length)
    //   if (this.countPositionSealListNew.length) {
    //     return this.countPositionSealListNew.length;
    //   } else {
    //     return ""
    //   }
    //
    // },
    // sealListWrapCalcHeight() {
    // 	// if (this.helpActive[0]) {
    // 	// 	return 612
    // 	// } else {
    // 	// 	return 640
    // 	// }
    // 	return 640

    // }
    showPasswordType(){
      return this.isShowPassword ? 'text' : 'password'
    },
	},
	created() {
		this.sid = this.$route.query.sid;
    this.taskName = this.$route.query.taskName;
		this.getTaskInfoApi();
		if (this.$store.state.handwriteBase64 && this.$store.state.handwriteSealId) {
			this.customHandwriteImg = this.$store.state.handwriteBase64;
			this.customHandwriteSealId = this.$store.state.handwriteSealId
		}
    document.title = "电子签章";
		//设置网页图标
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    // link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = 'http://49.4.7.22:8010/static/pc/sealLogo.png';
    document.getElementsByTagName('head')[0].appendChild(link);
  },
	mounted() {
    const _this = this;
		let disX = 0;
		let disY = 0;
		const receiverDom = document.querySelector("#contract-imgs");
		const contractContractDom = document.querySelector(".contract-content");
		receiverDom.onmousedown = () => {
			if (this.positonExistFlag) {
				return;
			}
			const event = event || window.event;
			event.stopPropagation();
			if (
				event.target.classList.contains("el-icon-circle-close") ||
				event.target.classList.contains("contract-img") ||
				event.target.classList.contains("file-item") ||
				event.target.classList.contains("box-head")
			) {
				return;
			}
			let target = event.target;
			while (
				target.tagName != "BODY" &&
				!target.className.includes("drag-box")
			) {
				target = target.parentNode;
			}
			const type = target.getAttribute("data-type");
			const offsetLeft = target.offsetLeft;
			const offsetTop = target.offsetTop;
			const pageHeight = receiverDom
				.querySelectorAll(".file-item")
			[_this.active].querySelectorAll(".img-wrap")[0].offsetHeight;
			disX = event.clientX;
			disY = event.clientY;
			document.onmousemove = function (event) {
				const event2 = event || window.event;
				let iL = event2.clientX - disX + offsetLeft;
				let iT = event2.clientY - disY + offsetTop;
				let targetWrapScrollLeft = +contractContractDom.scrollLeft;
				const maxL = receiverDom.offsetWidth - target.offsetWidth + targetWrapScrollLeft;
				const maxT = receiverDom.offsetHeight - target.offsetHeight;

				// 骑缝章处理
				if (type == "paging") {
					iT <= 0 && (iT = 0);
					iT >= pageHeight - target.offsetHeight &&
						(iT = pageHeight - target.offsetHeight);
					target.style.left = maxL + "px";
					target.style.top = iT + "px";
				} else {
					iL <= 0 && (iL = 0);
					// iT <= 0 && (iT = 0);
					iL >= maxL && (iL = maxL);
					iT >= maxT && (iT = maxT);
					target.style.left = iL + "px";
					target.style.top = iT + "px";
				}
				// target.getElementsByClassName(
				// 	"delete-icon"
				// )[0].style.display = "none";
				return false;
			};
			document.onmouseup = function (event) {
				const event3 = event || window.event;
				// 骑缝章处理
				if (type == "paging") {
					// 更改每一个骑缝章的 top 值
					const allTargetPagingDoms = receiverDom
						.querySelectorAll(".file-item")
					[_this.active].querySelectorAll(
						'.paging-box[data-paging="' +
						target.getAttribute("data-paging") +
						'"]'
					);
					for (let i = 0; i < allTargetPagingDoms.length; i++) {
						allTargetPagingDoms[i].style.top = target.style.top;
					}
				} else {
					const pageHeight = receiverDom
						.querySelectorAll(".file-item")
					[_this.active].querySelectorAll(".img-wrap")[0].offsetHeight;
					_this.judgePage(
						target,
						+target.style.top.split("px")[0],
						pageHeight,
						target.offsetHeight
					);

					receiverDom
						.querySelectorAll(".file-item")
					[_this.active].querySelectorAll(".img-wrap")
					[target.getAttribute("data-page")].appendChild(target);
				}
				// target.getElementsByClassName("delete-icon")[0].style = "";
				document.onmousemove = null;
				document.onmouseup = null;
			};
		};

    this.showLocatePopover = true;
    this.showLocatePopoverNew = true;
		window.addEventListener("scroll", this.scrollEventHandler, true);
    document.body.addEventListener("mousedown", this.highlightEventHandler, true);
		// this.getDatePngSrcHandle()
		// this.getUserSealInfoHandle()
		// getSealListApi().then(res => {});
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.scrollEventHandler, true);
    window.removeEventListener("mousedown", this.highlightEventHandler, true);
	},

	methods: {
    // 滑动tab页签
    scrollTab(direction) {
      // if (this.list.length === 0) return
      let menu = document.querySelector('#tab-menu')
      // 计算ul宽度和当前
      let ulWidth = menu.clientWidth
      const getWidth = (idName) => {
        let li = document.querySelector(idName)
        return li.clientWidth
      }
      let liWidth = 0
      this.list.forEach((ele, index) => {
        liWidth = liWidth + getWidth(`#li${index}`)
      });
      // 根据方向和宽度计算偏移量
      if (liWidth < ulWidth) return
      let distance = this.offsetCount * 100

      if (direction === 'left') {
        if (this.offsetCount > 0) {
          this.offsetCount = this.offsetCount - 1
        }
      } else if (direction === 'right') {
        if ((ulWidth + distance) < liWidth) {
          this.offsetCount = this.offsetCount + 1
        }
      }
      distance = this.offsetCount * 100
      menu.scrollTo({
        'left': distance,
        'behavior': 'smooth'
      })
    },
    closeTitleTop() {
      // this.$confirm("退出后，当前编辑的内容无法保存，确定要退出吗？", "提示", {
      //   distinguishCancelAndClose: true,
      //   confirmButtonText: "确定退出",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   center: true,
      //   showClose: false
      // }).then(() => {
      //   this.$router.go(-1);
      // }).catch((action) => {
      //
      // });
      window.location.href=this.singVerifyForm.returnUrl
    },
	  //获取验证码
    getMsgAuthCode() {
      this.auth_time = 60;
      this.sendCode = false;
      getSmsVerificationCode({
        sid: this.sid,
      }).then((res) => {
            if (res.code != "200") {
              if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              }

              this.sendCode = true;
              this.auth_time = 60;
            } else {
              this.$message({
                message: "短信发送成功",
                type: "success",
              });
              // 倒计时
              this.auth_time = 60;
              var auth_timetimer = setInterval(() => {
                this.auth_time--;
                if (this.auth_time < 1) {
                  this.sendCode = true;
                  clearInterval(auth_timetimer);
                }
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err);
            // this.$message.error('服务器错误！');
          });
    },
    authWaysChange(val){
      this.sendCodeAlert=false;
      this.pinAlert=false;
      this.$forceUpdate();
      //清楚刷脸轮训的定时器
      if (this.getFaceAuthResultTimer) {
        clearInterval(this.getFaceAuthResultTimer);
        this.getFaceAuthResultTimer = null;
      }
      //刷脸
      if(val=='live'){
       this.getFaceAuthLinkStillApi();
      }
    },
    //
    getFaceAuthLinkStillApi(type){
      if(type=="refresh"){
        if (this.getFaceAuthResultTimer) {
          clearInterval(this.getFaceAuthResultTimer);
          this.getFaceAuthResultTimer = null;
        }
      }
      getFaceAuthLinkStill({
        sid:this.sid,
        callbackUrl:"https://www.baidu.com",
        needQrcode:'yes',
      }).then(res=>{
        if (res.code != "200") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
          if(res.message=="您点的太快了，请稍等片刻后重试"){

          }else{

          }
        } else {
          this.qrcodeUrl = res.data.authLinkQrcodeBase64;
          this.authId = res.data.authId;
          //轮训获取静默版刷脸认证链接结果
          this.pollingResult();
        }
      }).catch((err) => {
        this.$message.error('服务器错误！');
      });
    },
    //轮训获取静默版刷脸认证链接结果
    pollingResult(){
      if (this.getFaceAuthResultTimer) {
        clearInterval(this.getFaceAuthResultTimer);
        this.getFaceAuthResultTimer = null;
      }
      this.getFaceAuthResultTimer = setInterval(this.getFaceAuthResultApi, 1000);

    },
    getFaceAuthResultApi(){
      let that=this;
      getFaceAuthResult({
        authId:that.authId
      }).then(res=>{
        if(res.code!=200){
          // 报错停止轮训
          clearInterval(that.getFaceAuthResultTimer);
          this.getFaceAuthResultTimer = null;
          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          }

        }else{
          that.qrCodeStatus=res.data.status;
          if(that.qrCodeStatus!='wait' && that.qrCodeStatus!='pass'){
            clearInterval(this.getFaceAuthResultTimer);
          }
          if(that.qrCodeStatus=='pass'){
            this.authToken=res.data.authToken;
            if(this.authStep=='after'){
              this.handleSave();
            }else{
              this.singVerifySuccess=true;

            }
          }
        }


      })
    },
    //认证弹窗  提交
    singVerifyFormSubmit(authWays){
      switch (authWays) {
        //短信认证
        case 'sms':
          if(!this.singVerifyForm.vcode){
            this.$message({
              showClose: true,
              message: "请输入短信验证码!",
              type: "warning",
            });
            return
          }
          getAuthTokenBySmsVerificationCodeOpen({
            vcode: this.singVerifyForm.vcode,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.sendCodeAlert=true;
                this.sendCodeAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              }
            } else {
              this.sendCodeAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.singVerifySuccess=true;
              this.singVerifySuccess_time = 2;
              var singVerifySuccess_timer = setInterval(() => {
                this.singVerifySuccess_time--;
                if (this.singVerifySuccess_time < 1) {
                  clearInterval(singVerifySuccess_timer);
                  this.signLayer=true;
                }
              }, 1000);
              if(this.authStep=='before'){
                this.handleGetSignDetailInfo();
              }
            }
          }).catch((err) => {
            // this.$message.error('服务器错误！');
          });
          break
        case 'pin':
          if(!this.singVerifyForm.pin){
            this.$message({
              showClose: true,
              message: "请输入签署密码!",
              type: "warning",
            });
            return
          }
          getAuthTokenByPinOpen({
            pin:this.singVerifyForm.pin,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.pinAlert=true;
                this.pinAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              }
            } else {
              this.pinAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.singVerifySuccess=true;
              this.singVerifySuccess_time = 2;
              var singVerifySuccess_timer = setInterval(() => {
                this.singVerifySuccess_time--;
                if (this.singVerifySuccess_time < 1) {
                  clearInterval(singVerifySuccess_timer);
                  this.signLayer=true;
                }
              }, 1000);
              if(this.authStep=='before'){
                this.handleGetSignDetailInfo();
              }
            }
          })
          break
      }

    },
    //签署后认证弹窗  提交
    singVerifyFormSubmitAfter(authWays){
      switch (authWays) {
          //短信认证
        case 'sms':
          if(!this.singVerifyForm.vcode){
            this.$message({
              showClose: true,
              message: "请输入短信验证码!",
              type: "warning",
            });
            return
          }
          getAuthTokenBySmsVerificationCodeOpen({
            vcode: this.singVerifyForm.vcode,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.sendCodeAlert=true;
                this.sendCodeAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              }
            } else {
              this.sendCodeAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.autoSealDrawer=false;
              this.authMethodTypeVisible=false;
              this.handleSave();
            }
          }).catch((err) => {
            // this.$message.error('服务器错误！');
          });
          break
        case 'pin':
          if(!this.singVerifyForm.pin){
            this.$message({
              showClose: true,
              message: "请输入签署密码!",
              type: "warning",
            });
            return
          }
          getAuthTokenByPinOpen({
            pin:this.singVerifyForm.pin,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.pinAlert=true;
                this.pinAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              }
            } else {
              this.pinAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.autoSealDrawer=false;
              this.authMethodTypeVisible=false;
              this.handleSave();
            }
          })
          break
      }

    },
    authMethodTypeFun(authMethodType){
      this.authMethodType=authMethodType;
      this.sendCodeAlert=false;
      this.pinAlert=false;
      //清楚刷脸轮训的定时器
      if (this.getFaceAuthResultTimer) {
        clearInterval(this.getFaceAuthResultTimer);
        this.getFaceAuthResultTimer = null;
      }
      //刷脸
      if(authMethodType=='live'){
        this.getFaceAuthLinkStillApi();
      }
    },
    highlightEventHandler(e) {
      e = e || window.event;
      let target = e.target;
      while (
          target.tagName != "BODY" &&
          !String(target.className).includes("locate-indicator")
          ) {
        target = target.parentNode;
      }
      if (!String(target.className).includes("locate-indicator")) {
        Array.from(document.body.querySelectorAll(".highlight")).map(_item => {
          _item.classList.remove("highlight");
        });
      }
    },
		scrollEventHandler(e) {
			let timeId;
			e = e || window.event;
			if (
				e.target.classList &&
				e.target.classList.contains("contract-content")
			) {
				clearTimeout(timeId);
				timeId = setTimeout(() => {
					this.handleScroll();
				}, 100);
				// this.handleScroll();
			} else {
				clearTimeout(timeId);
			}
		},
    tabTitleChange(idx){
      this.active=idx;
      this.signFileInfoArray[this.active].current = 0;
      document.getElementsByClassName("contract-content")[0].scrollTo({
        top: 0, behavior: 'smooth'
      });
    },
		changeCollapse() {
			if (this.active === "") {
				this.active = this.lastActive;
			}
			this.lastActive = this.active;
			// this.$forceUpdate();
			this.signFileInfoArray[this.active].current = 0;
      document.getElementsByClassName("contract-content")[0].scrollTo({
        top: 0, behavior: 'smooth'
      });
			// document
			// 	.getElementById("contract-imgs")
			// 	.getElementsByClassName("file-item")
			// [this.active].getElementsByClassName("img-wrap")[0]
			// 	.scrollIntoView({
			// 		behavior: "auto", // 平滑过渡
			// 		block: "start", // 上边框与视窗顶部平齐。默认值
			// 	});
			this.isPaging = false;
		},
		handleScroll() {
			// dom滚动位置
			let scrollTop =
				document.getElementsByClassName("contract-content")[0].scrollTop;
			if (this.scrollWatchStatus) {
				let scaleFactor = 1;
				this.signFileInfoArray[this.active].fileImgArray.map((v, i) => {
					let offsetTop = document
						.getElementById("contract-imgs")
						.getElementsByClassName("file-item")
					[this.active].getElementsByClassName("img-wrap")[i].offsetTop;
					// 获取监听元素本身高度
					let scrollHeight = document
						.getElementById("contract-imgs")
						.getElementsByClassName("file-item")
					[this.active].getElementsByClassName("img-wrap")[i].scrollHeight;

					if (
						scrollTop >= offsetTop &&
						scrollTop <= offsetTop + scrollHeight * scaleFactor
					) {
						this.signFileInfoArray[this.active].current = i;
					}
				});
			}
		},
		handleChangeContractImg(imgIdx,isIndicator,signFileId) {
      // console.log(signFileId)
			// let timer;
			// this.signFileInfoArray[this.active].current = imgIdx;
			// this.scrollWatchStatus = false;
			// clearTimeout(timer);
			// timer = setTimeout(() => {
			// 	document
			// 		.getElementById("contract-imgs")
			// 		.getElementsByClassName("file-item")
			// 	[this.active].getElementsByClassName("img-wrap")
			// 	[imgIdx].scrollIntoView({
			// 		behavior: "auto", // smooth 平滑过渡
			// 		block: "start", // 上边框与视窗顶部平齐。默认值
			// 	});
      //
			// 	let timer;
			// 	clearTimeout(timer);
			// 	timer = setTimeout(() => {
			// 		this.scrollWatchStatus = true;
			// 	}, 1300);
			// }, 0);
      console.log(signFileId)
      let gutterHeight = 0;
      if (document.querySelectorAll(".img-wrap")[1]) {
        gutterHeight = +window
            .getComputedStyle(document.querySelectorAll(".img-wrap")[1], null)
            .marginTop.split("px")[0];
      }
      this.scrollTarget = (parseFloat(getStyle(document.querySelectorAll(".file-item")[this.active].getElementsByClassName("img-wrap")[0], "height")) + gutterHeight) * imgIdx;
      // 当选中缩略图时，不依赖滚动监听
      if (!isIndicator) {
        this.scrollWatchStatus = false;
        this.signFileInfoArray[this.active].current = imgIdx
      }
      document
          .getElementById("contract-imgs")
          .getElementsByClassName("file-item")
          [this.active]
      document.getElementsByClassName("contract-content")[0].scrollTo({
        top: this.scrollTarget, behavior: 'smooth'
      });
		},
    //手机号加密
    encryptPhoneNumber(phone) {
      const reg = /(\d{3})\d{4}(\d{4})/; // 正则表达式
      return String(phone).replace(reg, "$1****$2"); // 返回加密后的电话号码
    },
    getTaskInfoApi(){
      getTaskInfo({
        sid: this.sid
      }).then(res => {
        if(res.code!=200){

          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          }
          return
        }else {
          this.loaded = true;
          this.taskName=res.data.taskName;
          //
          this.authStep=res.data.authStep;
          //签署状态
          this.signStatusDialog=res.data.signStatus;
          if(this.signStatusDialog=="finish" || this.signStatusDialog=="expire"){
            this.signLayer=false;
          }
          switch (this.authStep){
            //签署前认证
            case 'before':
              this.signLayer=false;
              this.singVerifyForm=res.data;
              this.singVerifyForm.authWaysValue=res.data.authWays[0] || 'sms' //测试代码
              this.singVerifyForm.authWaysArr=[];

              res.data.authWays.map(item=>{
                  let value="";
                  if(item=='sms'){
                    value="短信验证"
                  }else if(item=="pin"){
                    value="签署密码验证"
                  }else if(item=="live"){
                    value="刷脸验证"
                  }
                  let obj={
                    label:item,
                    value:value
                  }
                  this.singVerifyForm.authWaysArr.push(obj)

              })

              break
            case 'after':
              // this.signLayer=false;
              this.singVerifyForm=res.data;
              this.singVerifyForm.authWaysValue=res.data.authWays[0] || 'sms' //测试代码
              this.singVerifyForm.authWaysArr=[];
              this.authMethodType=res.data.authWays[0];
              res.data.authWays.map(item=>{
                let obj={
                  label:'',
                  value:'',
                }
                let value="";
                obj.label=item;
                if(item=='sms'){
                  // value="短信验证"
                  obj.value="短信验证";
                }else if(item=="pin"){
                  obj.value="签署密码验证"
                }else if(item=="live"){
                  obj.value="刷脸验证"
                }

                this.singVerifyForm.authWaysArr.push(obj)

              })
              //  获取详情
                if(this.signStatusDialog!="finish" && this.signStatusDialog!="expire"){
                  this.handleGetSignDetailInfo()
                }
              break
            default:
              this.singVerifyForm=res.data;
              this.handleGetSignDetailInfo()
              break
          }
        }
      }).catch((err) => {
        this.loaded = true;
      });
    },

		handleGetSignDetailInfo() {
			getSignInfoPcAndH5({
        authToken:this.authToken,
				sid: this.sid,
			}).then((res) => {
				if (res.code != "200") {
          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          }
				} else {
					this.needHandwritten = res.data.needHandwritten;





					this.signStatus = res.data.signStatus;




					// this.positonExistFlag = false;
          //是否指定了盖章位置
					this.positonExistFlag = res.data.positonExist === "yes";

					// res.data.signFileInfoArray.map((item) => {
					//   // 骑缝章框回显处理
					//   let pushArr = [];
					//   if (item.filePositionArray) {
					//     item.filePositionArray.map((posItem) => {
					//       if (posItem.sealLocationType == "paging") {
					//         posItem.positionPage = 1;
					//         for (let i = 2, len = item.filePages; i <= len; i++) {
					//           pushArr.push({
					//             positionId: posItem.positionId,
					//             positionPage: i,
					//             positionY: posItem.positionY,
					//             sealType: posItem.sealType,
					//             sealLocationType: "paging",
					//           });
					//         }
					//       }
					//     });
					//     item.filePositionArray.push(...pushArr);
					//   }
					// });
          const countPositionSealList = [];
					res.data.signFileInfoArray.map((item, idx) => {
            let pushArr = [];
            if (item.filePositionArray && Array.isArray(item.filePositionArray)) {
              countPositionSealList[idx] = [];
              countPositionSealList[idx].push(...item.filePositionArray);
              item.filePositionArray.map((posItem) => {
                if (posItem.sealLocationType == "paging") {
                  posItem.positionPage = 1;
                  for (let i = 2, len = item.filePages; i <= len; i++) {
                    pushArr.push({
                      positionId: posItem.positionId,
                      positionPage: i,
                      positionY: posItem.positionY,
                      sealType: posItem.sealType,
                      sealLocationType: "paging",
                    });
                  }
                }
              });
              item.filePositionArray.push(...pushArr);
              item.filePositionArray.map(posItem => {
                posItem.sealId = null;
              })
            }
						item.current = 0;
						item.fileImgArray = item.fileImgArray.map((imgItem, imgIdx) => {
							let poss;
							if (item.filePositionArray) {


								poss = item.filePositionArray.filter((posItem) => {
									return posItem.positionPage - 1 == imgIdx;
								});
							}
							let obj = {};
							obj.src = imgItem;
							if (!this.signSucceed) {
								obj.poss = poss;
							}
							return obj;
						});
					});
					this.signFileInfoArray = res.data.signFileInfoArray;
          // 每一次拖入签章都更新该数组，删除签章同理
          this.countPositionSealList = countPositionSealList;
					this.sealInfoArray = res.data.sealInfoArray;


          // 印章排序
          const sequence = ["companyCommon", "person", "companyLegal", "companyAgent", "date"];
          res.data.sealInfoArray.sort((prev, next) => {
            return sequence.indexOf(prev.sealType) - sequence.indexOf(next.sealType)
          })
          // 印章分组
          const groups = res.data.sealInfoArray.reduce((groups, item) => {
            const key = item.sealType;
            if (!groups[key]) {
              groups[key] = [];
            }
            groups[key].push(item);
            return groups;
          }, {});

          this.sealInfoArrayMap = groups;

					this.lastActive = this.active;






					this.$nextTick(() => {
						document.getElementsByClassName("contract-img")[0].onload = (
							ev
						) => {
							this.renderOK = true;
							document.getElementsByClassName("contract-img")[0].onload = null;
						};

						let collapseContentNodeList = document
							.getElementsByClassName("contract-page")[0]
							.getElementsByClassName("el-collapse-item__content");
						for (
							let i = 0, len = collapseContentNodeList.length;
							i < len;
							i++
						) {
							collapseContentNodeList[i].style.maxHeight =
								document.getElementsByClassName("contract-page")[0]
									.offsetHeight -
								45 -
								48 * res.data.signFileInfoArray.length +
								"px";
						}
					});
				}
			});
		},
    hanleSaveFun(){
      //如果是后验证
      if(this.authStep=='after'){
        if (!document.querySelectorAll(".contract-img")[0]) {
          return;
        }
        //未指定签章位置时
        let sealMsg="";
        if(!this.positonExistFlag){
          if (Array.from(document.querySelectorAll(".file-item")).some(item => {
            return !item.querySelector(".drag-box")
          })) {
            let index=0;
            let fileItemDom=document.querySelectorAll(".file-item");
            let msg="";
            for (let i=0;i<fileItemDom.length;i++){
              if(!fileItemDom[i].querySelector(".drag-box")){
                index=i;
                // break
                this.handleSaveDialogMsg=this.signFileInfoArray[i].fileName
                msg+=`《${this.signFileInfoArray[i].fileName}》`
                continue
              }
            }

            this.handleSaveDialogVisible=true;
            this.handleSaveDialogMsg=`${msg}还没有盖章，请盖章后再次确认签署`
            return;
          }


          let fileItemDom=document.querySelectorAll(".file-item");
          //如果主体是企业
          if(this.singVerifyForm.signSubject=='company'){
            for (let a=0;a<fileItemDom.length;a++){
              //如果盖的章没有企业章  企业签署方必须有企业章，其他章可选
              if(!Array.from(fileItemDom[a].querySelectorAll(".drag-box")).some(item => {
                return item.getAttribute("data-seal-type")=='companyCommon' && item.getAttribute("data-type")!='paging'
              })){
                sealMsg+=`《${this.signFileInfoArray[a].fileName}》》缺少【企业章】，请盖章后再次确认签署.`
              }
            }
          }
          if(this.singVerifyForm.signSubject=='person'){
            for (let a=0;a<fileItemDom.length;a++){
              //如果盖的章没有企业章  企业签署方必须有企业章，其他章可选
              if(!Array.from(fileItemDom[a].querySelectorAll(".drag-box")).some(item => {
                return item.getAttribute("data-seal-type")=='person'
              })){
                // this.handleSaveDialogVisible=true;
                // this.handleSaveDialogMsg=`《${this.signFileInfoArray[a].fileName}》》缺少【个人章】，请盖章后再次确认签署`
                // return;
                sealMsg+=`《${this.signFileInfoArray[a].fileName}》》缺少【个人章】，请盖章后再次确认签署.`
              }
            }
          }

          if(sealMsg){
            this.handleSaveDialogVisible=true;
            this.handleSaveDialogMsg=sealMsg;
            return;
          }
        }

        //指定了位置的
        if (this.positonExistFlag) {
          let flag=false;
          this.countPositionSealList.map(item=>{
            item.map(_item => {
              if (!_item.sealId) {
                //有未盖章的位置
                flag=true;
              }
            })
          })
          if(flag){
          let pageTitle="";
          let index=0;
          let fileItemDom=document.querySelectorAll(".file-item");

          for (let i=0;i<fileItemDom.length;i++){
              index=i;
              let pageIndex="";
              let pageIndexArr=[];
              this.countPositionSealList[i].map(_item => {
                if (!_item.sealId) {
                  if(!pageIndexArr.includes(_item.positionPage)){
                    pageIndexArr.push(_item.positionPage)
                  }
                  pageIndexArr.sort(function(a, b) {
                    return a - b;
                  });
                }
              })
              pageIndexArr.map(it=>{
                pageIndex+=`第${it}页`
              })
            if(pageIndexArr.length){
              pageTitle+=`《${this.signFileInfoArray[index].fileName}》的${pageIndex}`;
            }

          }
          this.handleSaveDialogVisible=true;
          this.handleSaveDialogMsg=`${pageTitle}还没有盖章，请盖章后再次确认签署`
          return;
        }
        }
        this.authMethodTypeVisible=true;
      }else{
        this.handleSave();
      }
    },
		handleSave() {
			if (!document.querySelectorAll(".contract-img")[0]) {
				return;
			}
      //未指定签章位置时
      let sealMsg="";
      if(!this.positonExistFlag){
        if (Array.from(document.querySelectorAll(".file-item")).some(item => {
          return !item.querySelector(".drag-box")
        })) {
          let index=0;
          let fileItemDom=document.querySelectorAll(".file-item");
          for (let i=0;i<fileItemDom.length;i++){
            if(!fileItemDom[i].querySelector(".drag-box")){
              index=i;
              break
            }
          }
          this.handleSaveDialogVisible=true;
          this.handleSaveDialogMsg=`《${this.signFileInfoArray[index].fileName}》还没有盖章，请盖章后再次确认签署`
          return;
        }
        let fileItemDom=document.querySelectorAll(".file-item");
        //如果主体是企业
        if(this.singVerifyForm.signSubject=='company'){
          for (let a=0;a<fileItemDom.length;a++){
            //如果盖的章没有企业章  企业签署方必须有企业章，其他章可选
            if(!Array.from(fileItemDom[a].querySelectorAll(".drag-box")).some(item => {
              return item.getAttribute("data-seal-type")=='companyCommon' && item.getAttribute("data-type")!='paging'
            })){
              sealMsg+=`《${this.signFileInfoArray[a].fileName}》》缺少【企业章】，请盖章后再次确认签署.`
            }
          }
        }
        if(this.singVerifyForm.signSubject=='person'){
          for (let a=0;a<fileItemDom.length;a++){
            //如果盖的章没有企业章  企业签署方必须有企业章，其他章可选
            if(!Array.from(fileItemDom[a].querySelectorAll(".drag-box")).some(item => {
              return item.getAttribute("data-seal-type")=='person'
            })){
              sealMsg+=`《${this.signFileInfoArray[a].fileName}》》缺少【个人章】，请盖章后再次确认签署.`
            }
          }
        }

        if(sealMsg){
          this.handleSaveDialogVisible=true;
          this.handleSaveDialogMsg=sealMsg;
          return;
        }


      }
      //指定位置时
      if (this.positonExistFlag) {
        let flag=false;
        this.countPositionSealList.map(item=>{
          item.map(_item => {
            if (!_item.sealId) {
              //有未盖章的位置
              flag=true;
            }
          })
        })

        if(flag){
        let pageTitle="";
        let index=0;
        let fileItemDom=document.querySelectorAll(".file-item");

        for (let i=0;i<fileItemDom.length;i++){
          // if(!fileItemDom[i].querySelector(".drag-box")){
            index=i;
            // break
            let pageIndex="";
            let pageIndexArr=[];
            this.countPositionSealList[i].map(_item => {
                if (!_item.sealId) {
                  if(!pageIndexArr.includes(_item.positionPage)){
                    pageIndexArr.push(_item.positionPage)
                  }
                  pageIndexArr.sort(function(a, b) {
                    return a - b;
                  });
                  // pageIndex+=`第${_item.positionPage}页`
                }

              })
            pageIndexArr.map(it=>{
              pageIndex+=`第${it}页`
            })
          if(pageIndexArr.length) {
            pageTitle += `《${this.signFileInfoArray[index].fileName}》的${pageIndex}`;
          }
          // }
        }
        this.handleSaveDialogVisible=true;
        this.handleSaveDialogMsg=`${pageTitle}还没有盖章，请盖章后再次确认签署`
        return;
        }
      }
			let positionLocationList = [];
      //指定位置时
      if(this.positonExistFlag){
        this.countPositionSealList.map(item => {
          item.map(_item => {
            if (_item.sealId) {
              positionLocationList.push(_item);
            }
          })
        })
      }else{

        let contractWidth =
            +document
                .getElementById("contract-imgs")
                .getElementsByClassName("file-item")
                [this.active].getElementsByClassName("contract-img")[0].offsetWidth;
        let contractHeight =
            +document
                .getElementById("contract-imgs")
                .getElementsByClassName("file-item")
                [this.active].getElementsByClassName("contract-img")[0].offsetHeight;
        this.$refs.contract.querySelectorAll(".drag-box").forEach((item) => {
          let isPaging = item.getAttribute("data-type") == "paging";
          let obj = {
            sealId: item.getAttribute("data-seal-id"),
            sealType: item.getAttribute("data-seal-type"),
            sealLocationType: isPaging ? "paging" : "position"
          };
          if (this.positonExistFlag) {
            obj.positionId = item.parentNode.parentNode.getAttribute("data-pos-id");
          } else {
            obj.signFileId = this.signFileInfoArray[item.getAttribute("data-file")].signFileId;
            if (!isPaging) {
              obj.positionX = parseInt(
                  (+item.style.left.split("px")[0] / contractWidth) * 50000
              );
              obj.positionPage = +item.getAttribute("data-page") + 1;
            }
            obj.positionY = parseInt(
                (+item.style.top.split("px")[0] / contractHeight) * 50000
            );
          }
          // 非首页的骑缝章忽略掉，相当于去重
          if (!isPaging || (isPaging && item.getAttribute("data-page") == 0)) {
            positionLocationList.push(obj);
          }
        });
      }

      this.positionSealArray = positionLocationList;


				let loadingInstance = Loading.service({
					fullscreen: true,
				});
				this.signFinishLoading = true;





      signPcAndH5({
          authToken:this.authToken,
					sid: this.sid,
					positionSealArray: positionLocationList,
				}).
        then((res) => {
						this.$nextTick(() => {
							// 以服务的方式调用的 Loading 需要异步关闭
							loadingInstance.close();
						});
						if (res.code != 200) {
							this.signFinishLoading = false;
              if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              }

						} else {
							this.signSucceed = true;
							this.$message({
								message: "签署成功！",
								type: "success",
							});
							// if (res.data.returnUrl) {
							// 	this.countDownSecond = 5;
							// 	var timer = setInterval(() => {
							// 		this.countDownSecond--;
							// 		if (this.countDownSecond <= 0) {
							// 			this.countDownSecond = 0;
							// 		}
							// 	}, 1000)
							// 	setTimeout(() => {
							// 		this.signFinishLoading = false;
							// 		timer = null;
							// 		this.countDownSecond = 0;
							// 		clearInterval(timer);
							// 		location.href = res.data.returnUrl;
							// 	}, 5000);
							// } else {
								// this.signFinishLoading = false;
								// Array.from(document.querySelectorAll(".position-box")).map(item => {
								// 	item.parentNode.removeChild(item);
								// });
								// Array.from(document.getElementsByClassName("contract-imgs")[0].querySelectorAll(".drag-box")).map(item => {
								// 	item.parentNode.removeChild(item);
								// });
								// this.handleGetSignDetailInfo();

              // }
              this.signFinishLoading = false;
              Array.from(document.querySelectorAll(".position-box.has-seal")).map(item => {
                item.parentNode.removeChild(item);
              });
              Array.from(document.getElementsByClassName("contract-imgs")[0].querySelectorAll(".drag-box")).map(item => {
                item.parentNode.removeChild(item);
              });
              document.getElementById("set-sign").style.display='none';
              // document.getElementById("locateIndicator").style.display='none';
              document.getElementById("tabTitleBox").style.width="calc(100% - 238px)";
              this.showLocatePopoverNew=false;  //右下角定位icon隐藏
              this.showLocatePopover=false;//右下角定位icon隐藏
              this.qianshuzhuangtai=true;
              this.handleGetSignDetailInfo();
						}
					})
					.catch((err) => {
						this.signFinishLoading = false;
						this.$nextTick(() => {
							loadingInstance.close();
						});
						console.log(err);
					});


			// });






		},
		// 认证完，提交签署签署
		getAuthCodeHandle(data) {
			this.saveLoading = true;
			if (this.applyData) {
				signWithProcess({
					sid: this.sid,
					positionSealArray: this.positionSealArray,
					signAuthToken: data.signAuthToken,
					processName: this.applyForm.processName,
					processDesc: this.applyForm.processDesc,
				}).then((res) => {
					this.saveLoading = false;
					if (res.code != "200") {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning",
						});
					} else {
						this.applyOpen = false;
						this.$message({
							showClose: true,
							message: res.message,
							type: "success",
						});
						this.$router.push({
							path: "/user-space/contracts",
							query: {
								status: "all",
							},
						});
					}
				});
			} else {
				taskSign({
					sid: this.sid,
					positionSealArray: this.positionSealArray,
					signAuthToken: data.signAuthToken,
				}).then((res) => {
					this.saveLoading = false;
					if (res.code != "200") {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning",
						});
					} else {
						this.$message({
							showClose: true,
							message: res.message,
							type: "success",
						});
						this.$router.push({
							path: "/user-space/contracts",
							query: {
								status: "all",
							},
						});
					}
				});
			}
		},
		submitApplyHandle() {
			this.$refs.applyForm.validate((valid) => {
				if (valid) {
					this.$refs.auth.dialogVisible = true;
				} else {
				}
			});
			// this.applyOpen = false;
		},
		cancelApply() {
			this.applyOpen = false;
		},
		arrayUnique(arr, name) {
			var hash = {};
			return arr.reduce(function (item, next) {
				hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
				return item;
			}, []);
		},

		/**
			  *@method judgePage
			*@description 判定落在哪页，只针对 top 值
			*@param {Object} target 判定目标 dom 对象
			*@param {Number} targetTop 判定目标 dom 对象 top 值
			*@param {Number} pageHeight 外层 dom 对象高度
			*@param {Number} offsetHeight 判定目标 dom 对象高度
			*@return 无返回，改变原对象
		*/
		judgePage(target, targetTop, pageHeight, offsetHeight) {
			let gutterHeight = 0;
			if (document.querySelectorAll(".img-wrap")[1]) {
				gutterHeight = +window
					.getComputedStyle(document.querySelectorAll(".img-wrap")[1], null)
					.marginTop.split("px")[0];
			}
			// 判定范围
			const judgeScope = (offsetHeight - gutterHeight) / 2 + gutterHeight;
			const judgeExpression =
				targetTop -
				(Math.ceil(targetTop / (pageHeight + gutterHeight)) *
					(pageHeight + gutterHeight) -
					(gutterHeight + offsetHeight) / 2);
			// 多页计算

			let divider = target.getAttribute("data-page")
				? +target.getAttribute("data-page")
				: 0;

			divider += Math.floor(targetTop / (pageHeight + gutterHeight));

			if (divider < 0) {
				divider = 0;
				target.style.top = 0;
			} else {
				if (Math.abs(judgeExpression) < judgeScope) {
					// 进入判定范围
					const nextPageHeight =
						(pageHeight + gutterHeight) *
						Math.ceil(targetTop / (pageHeight + gutterHeight));
					if (judgeExpression <= 0) {
						// 移到上一页
						target.style.top = pageHeight - offsetHeight + "px";
					} else {
						// 移到下一页
						target.style.top = 0 + "px";
						divider++;
					}
				} else {
					target.style.top =
						((pageHeight + gutterHeight + targetTop) %
							(pageHeight + gutterHeight)) +
						"px";
				}
			}

			if (divider > this.contractImgs.length - 1) {
				divider = this.contractImgs.length - 1;
				target.style.top = pageHeight - offsetHeight + "px";
			}

			target.setAttribute("data-page", divider);
		},

		handleNewHandWrite() {
			this.handWriteDialogVisible = true;
			const _this = this;
			this.$nextTick(() => {
				_this.showDrawTip();
				const $main = document.querySelector("#seal-main");
				const canvas = document.querySelector("#seal-canvas");
				const signCanvas = document.querySelector("#draw-seal");
				const $drawTip = document.querySelector(".draw-tip");
				const ctx = canvas.getContext("2d");
				canvas.width = signCanvas.clientWidth;
				canvas.height = signCanvas.clientHeight;
				let lastPoint = null;

				$main.addEventListener("mousedown", (e) => {
					_this.hideDrawTip();
					let isDown = true;
					let drwawTipLeft = $drawTip.offsetLeft;
					let drwawTipTop = $drawTip.offsetTop;

					ctx.lineWidth = 3;
					ctx.strokeStyle = "#000000";
					ctx.lineCap = ctx.lineJoin = "round";
					// let x = (e.target.tagName == "CANVAS") ? e.layerX : (e.layerX + drwawTipLeft);
					// let y = (e.target.tagName == "CANVAS") ? e.layerY : (e.layerY + drwawTipTop);
					// ctx.lineTo(x, y);

					$main.addEventListener("mousemove", (e) => {
						if (!isDown) {
							return;
						}
						e.preventDefault();
						let x = (e.target.tagName == "CANVAS") ? e.layerX : (e.layerX + drwawTipLeft);
						let y = (e.target.tagName == "CANVAS") ? e.layerY : (e.layerY + drwawTipTop);

						if (lastPoint != null) {
							ctx.beginPath();
							ctx.moveTo(lastPoint.x, lastPoint.y);
							ctx.lineTo(x, y);
							ctx.stroke();
						}
						lastPoint = { x, y }
						// ctx.lineTo(x, y);

					});

					document.addEventListener("mouseup", (e) => {
						ctx.closePath();
						e.preventDefault();
						isDown = false;
						lastPoint = null;
						canvas.onmousemove = null;
						canvas.onmouseup = null;
						canvas.removeEventListener("mousemove", e => { });
						document.removeEventListener("mouseup", e => { });
					});

				});


			})
		},

		clearSign() {
			const canvas = document.querySelector("#seal-canvas");
			const signCanvas = document.querySelector("#draw-seal");
			const ctx = canvas.getContext("2d");
			ctx.clearRect(
				0,
				0,
				signCanvas.offsetWidth,
				signCanvas.offsetHeight
			);
			this.showDrawTip();
		},
		drawSign() {
			const basedata = document
				.querySelector("#seal-canvas")
				.toDataURL("image/png", 1);
			checkHandwrite({
				sid: this.sid,
				imgBase64: basedata
			}).then((res) => {
				if (res.code != "200") {
					this.$message({
						showClose: true,
						message: res.message,
						type: "warning",
					});
				} else {
					this.$store.commit("SET_HANDWRITEBASE64", basedata);
					this.$store.commit("SET_HANDWRITEBASESEALID", res.data.sealId);
					this.customHandwriteImg = basedata;
					this.handWriteDialogVisible = false;
					this.customHandwriteSealId = res.data.sealId;
				}
			}).catch(err => {
				console.log(err)
			})
		},
		hideDrawTip() {
			const drawTip = document.querySelector(".draw-tip");
			drawTip.style.display = "none";
		},

		showDrawTip() {
			const drawTip = document.querySelector(".draw-tip");
			drawTip.style.display = "block";
		},

		confirmDeleteHandwrite() {
			this.$confirm(`确定要删除当前手写签名吗？`, "提示", {
				confirmButtonText: "删除",
				cancelButtonText: "取消",
				type: "warning",
				center: true,
				showClose: false
			})
				.then(() => {
					this.$store.commit("SET_HANDWRITEBASE64", null);
					this.$store.commit("SET_HANDWRITEBASESEALID", null);
					this.customHandwriteImg = null;
				})
				.catch(() => { });
		},

		handleAutoSeal() {
			// let sealInfoArrayCopy = JSON.parse(JSON.stringify(this.sealInfoArray));
			// let sealInfoArrayCopy = JSON.parse(JSON.stringify(this.sealInfoArrayMap));
			this.sealInfoArrayMapAutoSeal = JSON.parse(JSON.stringify(this.sealInfoArrayMap));
			// let arrayMap = {};
			// sealInfoArrayCopy.map(item => {
			// 	item.check = false;
			// 	if (!arrayMap[item.sealType]) {
			// 		arrayMap[item.sealType] = [item]
			// 	} else {
			// 		arrayMap[item.sealType].push(item)
			// 	}
			// })
			// this.sealInfoArrayMapAutoSeal = arrayMap;
			// this.autoSealDialogVisible = true;
      this.autoSealDrawer = true;
		},

		handleSelectAutoSeal(item, list) {
			// list.map(_item => {
			// 	_item.check = false;
			// })
			// item.check = true;

      if (item.permissionType == 'disabled') {
        return
      }
      list.map(_item => {
        if (item === _item) {
          this.$set(item, 'check', !item.check);
        } else {
          this.$set(_item, 'check', false);
        }
      });
      let checkedAutoSealLength = 0;
      Object.keys(this.sealInfoArrayMapAutoSeal).map((_key) => {
        checkedAutoSealLength += this.sealInfoArrayMapAutoSeal[_key].filter(__item => {
          return __item.check
        }).length
      })
      this.checkedAutoSealLength = checkedAutoSealLength;
		},


		// handleCheckAutoSeal() {
		// 	let checkedSealList = [];
		// 	Object.keys(this.sealInfoArrayMapAutoSeal).map(key => {
		// 		this.sealInfoArrayMapAutoSeal[key].map(item => {
		// 			if (item.check) {
		// 				item.node = document.getElementById("set-sign").querySelector(`.sign-box[data-seal-id="${item.sealId}"]`);
		// 				checkedSealList.push(item)
		// 			}
		// 		})
		// 	})
		// 	let positionBoxList = Array.from(document.querySelectorAll(".position-box"));
		// 	checkedSealList.map(item => {
		// 		positionBoxList.map(nodeItem => {
		// 			if (nodeItem.getAttribute("data-seal-type") == item.sealType) {
    //
    //         // 更新签框统计数组
    //         // console.log(this.countPositionSealList[this.active])
    //         this.countPositionSealList[this.active].find(_item => {
    //           // console.log(_item.positionId === nodeItem.getAttribute("data-pos-id"), _item.sealId, item.sealId)
    //           return _item.positionId === nodeItem.getAttribute("data-pos-id")
    //         }).sealId = item.sealId;
    //
		// 				let itemNodeClone = item.node.cloneNode(true);
		// 				itemNodeClone.style.position = "relative";
		// 				itemNodeClone.style.left = "unset";
		// 				itemNodeClone.style.top = "unset";
		// 				const deleteDom = document.createElement("i");
		// 				deleteDom.setAttribute(
		// 					"class",
		// 					"el-icon-circle-close delete-icon"
		// 				);
		// 				deleteDom.addEventListener("click", function () {
		// 					itemNodeClone.parentNode.removeChild(itemNodeClone);
		// 				});
		// 				itemNodeClone.appendChild(deleteDom);
		// 				if (nodeItem.querySelector(".sign-box")) {
		// 					nodeItem.querySelector(".sign-box").parentNode.removeChild(nodeItem.querySelector(".sign-box"))
		// 				}
		// 				nodeItem.lastElementChild.appendChild(itemNodeClone);
		// 			}
		// 		})
		// 	})
		// 	this.autoSealDialogVisible = false;
		// },
    handleCheckAutoSeal() {
		  let that=this;
      let checkedSealList = [];
      let contractDom = document.querySelector("#contract-imgs");
      Object.keys(this.sealInfoArrayMapAutoSeal).map(key => {
        this.sealInfoArrayMapAutoSeal[key].map(item => {
          if (item.check) {
            item.node = document.getElementById("set-sign").querySelector(`.sign-box[data-seal-id="${item.sealId}"]`);
            checkedSealList.push(item)
          }
        })
      })
      if (!checkedSealList.length) {
        this.$message({
          message: "请选择印章",
          type: "warning",
        });
        return;
      }
      let positionBoxList = Array.from(contractDom
          .querySelectorAll(".file-item")
          [this.active].querySelectorAll(".position-box"));
      checkedSealList.map(item => {
        positionBoxList.map(nodeItem => {
          this.$nextTick(() => {
            if (nodeItem.getAttribute("data-seal-type") == item.sealType) {


              // 更新签框统计数组
              this.countPositionSealList[this.active].find(_item => {
                // console.log(_item.positionId === nodeItem.getAttribute("data-pos-id"), _item.sealId, item.sealId)
                return _item.positionId === nodeItem.getAttribute("data-pos-id")
              }).sealId = item.sealId;

              let itemNodeClone = item.node.cloneNode(true);
              itemNodeClone.style.position = "relative";
              itemNodeClone.style.left = "unset";
              itemNodeClone.style.top = "unset";
              // itemNodeClone.style.marginTop = "30px";

              nodeItem.classList.add("has-seal");
              nodeItem.querySelector(".seal-name").innerHTML = item.sealName;


              if (nodeItem.querySelector(".sign-box")) {
                nodeItem.querySelector(".sign-box").parentNode.removeChild(nodeItem.querySelector(".sign-box"))
              }
              nodeItem.lastElementChild.appendChild(itemNodeClone);

              // const deleteDom = document.createElement("i");
              // deleteDom.setAttribute(
              //   "class",
              //   "el-icon-circle-close delete-icon"
              // );
              // deleteDom.addEventListener("click", function () {
              //   let posItemPositionId=itemNodeClone.parentNode.parentNode.getAttribute("data-pos-id")
              //   that.countPositionSealList[that.active].find(item => {
              //     return item.positionId === posItemPositionId;
              //   }).sealId = null;
              //   itemNodeClone.parentNode.removeChild(itemNodeClone);
              //
              // });
              // itemNodeClone.appendChild(deleteDom);

            }
          })
        })
      })
      this.autoSealDrawer = false;
    },
    handlePageUp() {
      this.handleChangeContractImg(0, true);
    },
    handlePageDown() {
      this.handleChangeContractImg(this.signFileInfoArray[this.active].fileImgArray.length - 1, true);
    },
    //快速定位未盖章的位置  指定位置
    handleQuickLocateNotSeal() {
      if (this.notSealCount) {
        // 根据top排序
        const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box:not(.has-seal)");
        const fullTargetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box");
        const sortedDomsByTop = Array.from(targetDoms).sort((prev, next) => {
          return prev.getBoundingClientRect().top - next.getBoundingClientRect().top;
        })
        const targetDom = sortedDomsByTop[0];
        console.log(targetDom)
        // 让目标滚到屏幕中间
        const calcTop = targetDom.getBoundingClientRect().top + document.getElementsByClassName("contract-content")[0].scrollTop
            - (document.documentElement.offsetHeight / 2) + (targetDom.offsetHeight / 2);
        document.getElementsByClassName("contract-content")[0].scrollTo({
          top: calcTop, behavior: 'smooth'
        });
        Array.from(fullTargetDoms).map(_item => {
          if (_item.classList.contains("highlight")) {
            _item.classList.remove("highlight");
          }
        });
        setTimeout(() => {
          targetDom.classList.add("highlight");
        }, 100)

        // targetDom.focus();
      } else {
        // 如果已经全部落章了，则依次步进定位已落章的框
        const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box");
        const sortedDomsByTop = Array.from(targetDoms).sort((prev, next) => {
          return prev.getBoundingClientRect().top - next.getBoundingClientRect().top;
        });
        this.locatePositionBoxByStepIdx++;
        if (this.locatePositionBoxByStepIdx > sortedDomsByTop.length - 1) {
          this.locatePositionBoxByStepIdx = 0;
        }
        const targetDom = sortedDomsByTop[this.locatePositionBoxByStepIdx];
        // 让目标滚到屏幕中间
        const calcTop = targetDom.getBoundingClientRect().top + document.getElementsByClassName("contract-content")[0].scrollTop
            - (document.documentElement.offsetHeight / 2) + (targetDom.offsetHeight / 2);
        document.getElementsByClassName("contract-content")[0].scrollTo({
          top: calcTop, behavior: 'smooth'
        });
        Array.from(targetDoms).map(_item => {
          if (_item.classList.contains("highlight")) {
            _item.classList.remove("highlight");
          }
        });
        setTimeout(() => {
          targetDom.classList.add("highlight");
        }, 100)
        // targetDom.focus();
      }

    },
    //快速定位已盖章的位置
    handleQuickLocateSeal() {
        // 如果已经全部落章了，则依次步进定位已落章的框
        // const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box");
        const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".sign-img-box");
      let newArr=[];
      targetDoms.forEach(item=>{
       if(item.getAttribute('data-type')=='paging'){
         let flag=false;
         newArr.forEach(it=>{
           if(it.getAttribute('data-type')=='paging'){
             flag=true
           }
         })
         if(!flag){
           newArr.push(item)
         }
       }else{
         newArr.push(item)
       }
      })
        const sortedDomsByTop = Array.from(newArr).sort((prev, next) => {
          return prev.getBoundingClientRect().top - next.getBoundingClientRect().top;
        });
        this.locateNotPositionBoxByStepIdx++;
        if (this.locateNotPositionBoxByStepIdx > sortedDomsByTop.length - 1) {
          this.locateNotPositionBoxByStepIdx = 0;
        }
        const targetDom = sortedDomsByTop[this.locateNotPositionBoxByStepIdx];
        if(!targetDom){return}
        // 让目标滚到屏幕中间
        const calcTop = targetDom.getBoundingClientRect().top + document.getElementsByClassName("contract-content")[0].scrollTop
            - (document.documentElement.offsetHeight / 2) + (targetDom.offsetHeight / 2);
        document.getElementsByClassName("contract-content")[0].scrollTo({
          top: calcTop, behavior: 'smooth'
        });
        Array.from(newArr).map(_item => {
          if (_item.classList.contains("highlight")) {
            _item.classList.remove("highlight");
          }
        });
        setTimeout(() => {
          targetDom.classList.add("highlight");
        }, 100)
        // targetDom.focus();


    },
    handleDeleteInnerSeal(posItem, $event) {
      const target = $event.target;
      const $parent = target.parentNode;
      const $$parent = target.parentNode.parentNode;
      if ($$parent.getAttribute("data-type") == "paging") {
        const contractDom = document.querySelector("#contract-imgs");
        // 删除所有相同id的骑缝章
        const targetPagingId = $$parent.getAttribute("data-pos-id");
        const allTargetPagingDoms = contractDom
            .querySelectorAll(".file-item")
            [this.active].querySelectorAll(
            '.position-box[data-pos-id="' +
            targetPagingId +
            '"] .drag-box'
        );
        for (let i = 0; i < allTargetPagingDoms.length; i++) {
          allTargetPagingDoms[i].parentNode.classList.remove("has-seal");
          allTargetPagingDoms[i].parentNode.parentNode.classList.remove("has-seal");
          allTargetPagingDoms[i].parentNode.querySelector(".seal-name").innerHTML = "";
          allTargetPagingDoms[i].parentNode.removeChild(
              allTargetPagingDoms[i]
          );
        }
        this.countPositionSealList[this.active].find(item => {
          return item.positionId === posItem.positionId;
        }).sealId = null;
      } else {
        $parent.removeChild($parent.querySelector(".sign-box"));
        $$parent.classList.remove("has-seal");
        $$parent.querySelector(".seal-name").innerHTML = "";

        this.countPositionSealList[this.active].find(item => {
          return item.positionId === posItem.positionId;
        }).sealId = null;
      }


    },
    showLocatePopoverFalse() {
      this.showLocatePopover = false;
    },
    //未定位时已拖拽的签章数量
    showLocatePopoverTrue() {
      this.showLocatePopoverNew = false;
    },
    handleBackHome() {
      // this.$router.replace("/");
      window.location.href=this.singVerifyForm.returnUrl;
    },

	},
	directives: {
		drop: {
			inserted: function (el, binding, vnode) {
			  let that=this;
				let disX = 0;
				let disY = 0;
				let contractImgs =
					document.querySelector("#contract-imgs").parentNode.parentNode;
				let contractDom = document.querySelector("#contract-imgs");
				let contractContractDom = document.querySelector(".contract-content");
				let main = document.querySelector("#main");
				let asideDom = document.querySelector("#set-sign");

				// 获取所有图片，拖拽不在浏览器新页面打开
				Array.from(document.getElementsByTagName("img")).forEach((img) => {
					img.ondragstart = function () {
						return false;
					};
				});

				el.onmousedown = function (event) {
					const asideTop = asideDom.getBoundingClientRect().top;
					const asideLeft = asideDom.getBoundingClientRect().left;
					const scrollTop = document.querySelector(".seal-list-wrap").scrollTop;
					event = event || window.event;
					// disX = event.clientX - this.offsetLeft;
					disX = event.clientX;
					// disY = event.clientY - this.offsetTop + asideDom.scrollTop;
					disY = event.clientY;

          const contractDomTop = contractDom.getBoundingClientRect().top;
          const startTop = el.getBoundingClientRect().top;
          const startLeft = el.getBoundingClientRect().left;

					let cloneTemp = el.cloneNode(true);
					cloneTemp.style.position = "fixed";
					cloneTemp.style.zIndex = 999;
					// cloneTemp.style.left = this.currentStyle
					// 	? this.currentStyle["left"]
					// 	: getComputedStyle(this, null)["left"];
          cloneTemp.style.left = startLeft + "px";
					// cloneTemp.style.top = event.clientY - disY + main.offsetTop - scrollTop + "px";
          cloneTemp.style.top = startTop + "px";
					cloneTemp.style.cursor = "grab";
					cloneTemp.style.opacity = ".4";
					el.parentNode.appendChild(cloneTemp);

					document.onmousemove = function (event) {
						event = event || window.event;
						let iL = event.clientX - disX;
						let iT = event.clientY - disY;
						let maxL = document.documentElement.clientWidth - el.offsetWidth;
						let maxT = document.documentElement.clientHeight - el.offsetHeight;
						iL <= 0 && (iL = 0);
						// iT <= 0 && (iT = 0);
            iT + startTop - contractDomTop <= 0 && (iT = - startTop + contractDomTop);

            iL >= maxL && (iL = maxL);
						iT >= maxT && (iT = maxT);
						// cloneTemp.style.left = iL + main.offsetLeft + "px";
						// cloneTemp.style.top = iT + main.offsetTop - scrollTop + "px";
            cloneTemp.style.top = iT + el.getBoundingClientRect().top + "px";
            cloneTemp.style.left = iL + el.getBoundingClientRect().left + "px";
						return false;
					};

					// 兼容有章框和无章框情况，统一判断处理
					document.onmouseup = function (event) {
						event = event || window.event;
						let targetLeft = +cloneTemp.style.left.split("px")[0];
						let targetTop = +cloneTemp.style.top.split("px")[0];
						let targetWidth = +cloneTemp.offsetWidth;
						let targetHeight = +cloneTemp.offsetHeight;
						let targetSealType = cloneTemp.getAttribute("data-seal-type");
						let targetWrapScrollLeft = +contractContractDom.scrollLeft;
						document.onmousemove = null;
						document.onmouseup = null;
						// 无签章框情况
						if (!vnode.context.positonExistFlag) {

							let contractDomLeft = contractDom.getBoundingClientRect().left;
							let contractDomTop = contractDom.getBoundingClientRect().top;
							if (
								targetLeft >= contractDomLeft + targetWrapScrollLeft &&
								targetLeft <=
								contractDomLeft + contractDom.offsetWidth - targetWidth + targetWrapScrollLeft &&
								targetTop >= contractDomTop &&
								targetTop <=
								contractDomTop + contractDom.offsetHeight - targetHeight
							) {
								targetTop = targetTop - contractDomTop;
								targetLeft = targetLeft - contractDomLeft;
								const pageHeight = contractDom
									.querySelectorAll(".file-item")
								[vnode.context.active].querySelectorAll(
									".contract-img"
								)[0].offsetHeight;
								const headDom = document.createElement("div");
								headDom.setAttribute("class", "box-head");
								let type = vnode.context.isPaging && targetSealType == "companyCommon" ? "paging" : "";
								const deleteDom = document.createElement("i");
								deleteDom.setAttribute("class", "el-icon-circle-close delete-icon");
								deleteDom.addEventListener("click", function () {
									cloneTemp.parentNode.removeChild(cloneTemp);
                  vnode.context.sealCount--;
                  if(vnode.context.sealCount<0){
                    vnode.context.sealCount=0;
                  }
								});
								headDom.appendChild(deleteDom);
								cloneTemp.appendChild(headDom);
								cloneTemp.setAttribute("data-file", vnode.context.active);
								cloneTemp.style.position = "absolute";
								cloneTemp.style.left = targetLeft + "px";
								cloneTemp.style.top = targetTop + "px";
								cloneTemp.style.opacity = "1";
								cloneTemp.style.border = "1px dashed #448DF7";
								cloneTemp.style.borderRadius = "6px";
								cloneTemp.style.background="rgba(68, 141, 247, 0.05)";
                //个人签名
								if(targetSealType=='person'){
                  cloneTemp.style.width = "140px";
                  cloneTemp.style.height = "70px";
                }else if(targetSealType=='companyCommon'){
								  //企业章
                  cloneTemp.style.width = "140px";
                  cloneTemp.style.height = "140px";
                }else if(targetSealType=="companyLegal"){
								  //法定代表人章
                  cloneTemp.style.width = "140px";
                  // cloneTemp.style.height = "70px";
                  // cloneTemp.style.padding = "0px 30px";
                }else if(targetSealType=="date"){
                  //日期章
                  cloneTemp.style.height = "40px";
                }
								contractDom.appendChild(cloneTemp);
								targetWidth = +cloneTemp.offsetWidth;
								targetHeight = +cloneTemp.offsetHeight;
								let contractContractDomScrolledWidth = contractContractDom.querySelector(".img-wrap").offsetWidth - contractContractDom.querySelector(".contract-img-content").offsetWidth;
								// 签框不能超出合同图片宽，骑缝章处理
								if (

									type == "paging"
								) {
									// cloneTemp.style.left =
									// 	contractDom.offsetWidth - targetWidth + contractContractDomScrolledWidth + "px";
                  cloneTemp.style.left =
                      contractDom.offsetWidth - targetWidth + "px";
                }
								vnode.context.judgePage(
									cloneTemp,
									targetTop,
									pageHeight,
									targetHeight
								);
								// 向每一页添加骑缝章
								if (type == "paging") {
									const targetPagingId =
										"paging" + vnode.context.active + vnode.context.pagingId;
									cloneTemp.setAttribute("data-paging", targetPagingId);
									cloneTemp.setAttribute("data-type", "paging");
									cloneTemp.className += " paging-box";
									vnode.context.pagingId++;
									const allPageDoms = contractDom
										.querySelectorAll(".file-item")
									[vnode.context.active].querySelectorAll(".img-wrap");
                  if(allPageDoms.length<2){
                    vnode.context.$message({
                      showClose: true,
                      message: "单页文件不支持加盖骑缝章",
                      type: "warning",
                    });
                    contractDom.removeChild(cloneTemp);
                  }else{
                    for (let i = 0; i < allPageDoms.length; i++) {
                      let secondColoneTemp =
                          i == 0 ? cloneTemp : cloneTemp.cloneNode(true);
                      secondColoneTemp.setAttribute("data-page", i);
                      secondColoneTemp
                          .getElementsByClassName("delete-icon")[0]
                          .addEventListener("click", function () {
                            // 删除每一个骑缝章
                            const allTargetPagingDoms = contractDom
                                .querySelectorAll(".file-item")
                                [vnode.context.active].querySelectorAll(
                                '.paging-box[data-paging="' + targetPagingId + '"]'
                            );
                            for (let i = 0; i < allTargetPagingDoms.length; i++) {
                              allTargetPagingDoms[i].parentNode.removeChild(
                                  allTargetPagingDoms[i]
                              );

                            }
                          });
                      allPageDoms[i].appendChild(secondColoneTemp);
                    }
                    vnode.context.sealCount++;

                  }
								} else {
									contractDom
										.querySelectorAll(".file-item")
									[vnode.context.active].querySelectorAll(".img-wrap")
									[cloneTemp.getAttribute("data-page")].appendChild(cloneTemp);
                  vnode.context.sealCount++;
								}

							} else {
								el.parentNode.removeChild(cloneTemp);
							}
						} else {

							cloneTemp.style.position = "absolute";
							cloneTemp.style.zIndex = 9;
							cloneTemp.style.opacity = 1;
							// cloneTemp.style.left =
							// 	targetLeft -
							// 	contractDom.offsetLeft +
							// 	contractDom.parentNode.parentNode.scrollLeft -
							// 	asideLeft +
							// 	"px";
							// cloneTemp.style.top =
							// 	targetTop +
							// 	contractDom.parentNode.parentNode.scrollTop -
							// 	asideTop +
							// 	"px";

							targetLeft = +cloneTemp.style.left.split("px")[0];
							targetTop = +cloneTemp.style.top.split("px")[0];

							// 判定落入签章框
							const sealAnchors = contractDom
								.querySelectorAll(".file-item")
							[vnode.context.active].querySelectorAll(".position-box");
							const judgeScope = vnode.context.judgeScope;
							let catcher = null;
							for (let i = 0, len = sealAnchors.length; i < len; i++) {

								// 取两判定物体中心点比较
								let sealAnchorCenterLeft =
									// sealAnchors[i].offsetLeft + sealAnchors[i].offsetWidth / 2;
                    sealAnchors[i].getBoundingClientRect().left + sealAnchors[i].offsetWidth / 2;
								// let sealAnchorCenterTop =
								// 	sealAnchors[i].parentNode.offsetTop +
								// 	sealAnchors[i].offsetTop +
								// 	sealAnchors[i].offsetHeight / 2;
								let sealAnchorCenterTop =
                    sealAnchors[i].getBoundingClientRect().top+
									sealAnchors[i].offsetHeight / 2;

                let setSignWidth=asideDom.getBoundingClientRect().width;


								// let targetCenterLeft = targetLeft + targetWidth / 2-sealAnchors[i].parentNode.getBoundingClientRect().left;
								let targetCenterLeft = targetLeft + targetWidth / 2;
								let targetCenterTop = targetTop + targetHeight / 2 ;
								if (
									Math.abs(sealAnchorCenterLeft - targetCenterLeft) <=
									judgeScope &&
									Math.abs(sealAnchorCenterTop - targetCenterTop) <=
									judgeScope
								) {
									// 去掉30 box-head 标题高度
									// 落入捕获
									catcher = sealAnchors[i];
								}
							}
							if (catcher) {
								// 骑缝章可以拖入签章和签名
								if (
									cloneTemp.getAttribute("data-seal-type") !==
									catcher.getAttribute("data-seal-type")
								) {
									vnode.context.$message({
										message: "您不能在此位置盖章",
										type: "warning",
									});
									el.parentNode.removeChild(cloneTemp);
									return;
								}

								if (catcher.getElementsByClassName("drag-box")[0]) {
									vnode.context.$message({
										message: "要拖入的签章位置已存在其他签章",
										type: "warning",
									});
									el.parentNode.removeChild(cloneTemp);
									return;
								}


								if (catcher.getAttribute("data-type") == "paging") {
									// 为所有同一positionId骑缝章框加入骑缝章
									const allPagingPosBoxDoms = contractDom
										.querySelectorAll(".file-item")[vnode.context.active].querySelectorAll(
										'.position-box[data-pos-id="' +catcher.getAttribute("data-pos-id") +'"] .paging-pos-box'
									);
									for (let i = 0; i < allPagingPosBoxDoms.length; i++) {
										let secondColoneTemp =
											i == 0 ? cloneTemp : cloneTemp.cloneNode(true);
										secondColoneTemp.style.position = "relative";
										secondColoneTemp.style.left = "unset";
										secondColoneTemp.style.top = "unset";
										// const deleteDom = document.createElement("i");
										// deleteDom.setAttribute(
										// 	"class",
										// 	"el-icon-circle-close delete-icon"
										// );
										// deleteDom.addEventListener("click", function (e) {
										// 	// 删除所有相同id的骑缝章
										// 	const targetPagingId = catcher.getAttribute("data-pos-id");
										// 	const allTargetPagingDoms = contractDom
										// 		.querySelectorAll(".file-item")
										// 	[vnode.context.active].querySelectorAll(
										// 		'.position-box[data-pos-id="' +
										// 		targetPagingId +
										// 		'"] .drag-box'
										// 	);
										// 	for (let i = 0; i < allTargetPagingDoms.length; i++) {
										// 		allTargetPagingDoms[i].parentNode.removeChild(
										// 			allTargetPagingDoms[i]
										// 		);
										// 	}
										// });
										// secondColoneTemp.appendChild(deleteDom);
										allPagingPosBoxDoms[i].appendChild(secondColoneTemp);
                    allPagingPosBoxDoms[i].parentNode.classList.add("has-seal");
                    allPagingPosBoxDoms[i].querySelector(".seal-name").innerHTML = cloneTemp.getAttribute("data-seal-name");
									}
                  vnode.context.countPositionSealList[vnode.context.active].find(_item => {
                    return _item.positionId === allPagingPosBoxDoms[0].parentNode.getAttribute("data-pos-id")
                  }).sealId = cloneTemp.getAttribute("data-seal-id");
								} else {

                  // 签章落框的一系列必要操作
                  // 为捕获签章框添加状态类
                  catcher.classList.add("has-seal");
                  catcher.querySelector(".seal-name").innerHTML = cloneTemp.getAttribute("data-seal-name");
                  // catcher.querySelector(".seal-name").innerHTML = "12341234123";
                  // 更新签框统计数组
                  vnode.context.countPositionSealList[vnode.context.active].find(_item => {
                    return _item.positionId === catcher.getAttribute("data-pos-id")
                  }).sealId = cloneTemp.getAttribute("data-seal-id");
                  // end
									cloneTemp.style.position = "relative";
									cloneTemp.style.left = "unset";
									cloneTemp.style.top = "unset";
									// const deleteDom = document.createElement("i");
									// deleteDom.setAttribute(
									// 	"class",
									// 	"el-icon-circle-close delete-icon"
									// );
									// deleteDom.addEventListener("click", function () {
                  //   let posItemPositionId=cloneTemp.parentNode.parentNode.getAttribute("data-pos-id")
                  //   vnode.context.countPositionSealList[vnode.context.active].find(item => {
                  //     return item.positionId === posItemPositionId;
                  //   }).sealId = null;
									// 	cloneTemp.parentNode.removeChild(cloneTemp);
									// });
									// cloneTemp.appendChild(deleteDom);
									catcher.lastElementChild.appendChild(cloneTemp);
								}
							} else {
								el.parentNode.removeChild(cloneTemp);
							}
						}
					};
				};
			},
		},

		maxIndex: {
			inserted: function (el, binding) {
				var customDrags = document.getElementsByClassName("custom-drag");
				el.onclick = function () {
					for (var i = 0; i < customDrags.length; i++) {
						customDrags[i].style.zIndex = 9;
					}
					el.style.zIndex = 9999;
				};
			},
		},
	},
};
</script>
<style lang="scss" scoped>
.title-top {
  height: 54px;
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #F2F3F5;
  background: #fff;

  .title {
    margin-left: 12px;
  }

  .title-left {
    width: 220px;
  }

  .center-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    color: #86909C;
    padding-left: 20px;
    border-left: 1px solid #F2F3F5;
  }
  .qianshuzhuangtai{
    padding-left: 20px;
    text-align: center;
    img{
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 11px;
      margin-bottom: 2px;
    }
    .txt{
      font-size: 14px;
      font-weight: 500;
      color: #38A65A;
    }
  }

  .el-button {
    height: 30px;
    line-height: 30px;
  }

  .el-button /deep/ span {
    display: flex;
    align-items: center;

    svg {
      margin-right: 8px;
    }
  }
}
.main-container{
  background: #f0f0f5;
  //height: 100vh;
  //overflow: hidden;
  .singVerify{
    width: 80%;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 30px auto 30px auto;
    padding-bottom: 90px;
    position: relative;
    .singVerify-head{
      padding:20px 32px 48px 32px;
      .img{
        width: 17px;
        height: 20px;
        margin-right: 10px;
      }
      .txt{
       width: 120px;
        height: 20px;
      }
    }
    .signVerify-body{
      width: 502px;
      //height: 480px;
      border-radius: 0px 0px 10px 10px;
      opacity: 1;
      background: #F5F8FD;
      box-sizing: border-box;
      border: 1px solid #E3EAF4;
      box-shadow: 0px 8px 16px 0px rgba(12, 38, 94, 0.1);
      font-size: 0;
      margin: 0 auto;
      .tiao{
        margin-bottom: 30px;
      }
      .signVerify-form{
        font-size: 14px;
        margin: 25px 40px 25px 40px;
        /deep/ .el-radio-group .el-radio{
          margin-right: 15px;
        }
        /deep/ .el-radio-group .el-radio:last-child{
          margin-right: 0px;
        }
        /deep/ .el-radio-group .el-radio__input.is-checked+.el-radio__label{
          color: #3F7BF9;
        }
        /deep/ .el-form-item{
          margin-right: 0;
        }
        .qrcode-box{
          width: 160px;
          height: 160px;
          margin: 0 auto;
          position: relative;
          .code-img{
            width: 160px;
            height: 160px;
            vertical-align: baseline;
          }
          .mask{
            width: 160px;
            height: 160px;
            border-radius: 6px;
            background: rgba(255,255,255,0.9);
            margin: 0 auto;
            position: absolute;
            top: 0;
            left: 0;
            .icon{
              width: 36px;
              height: 36px;
              position: absolute;
              top: 50px;
              left: 60px;
            }

          }
          .success{
            border: 2px solid #38A65A;
            .txt{
              position: absolute;
              top: 90px;
              left: 57px;
              color: #38A65A
            }
          }
          .warning{
            border: 2px solid #EFB040;
            .txt{
              position: absolute;
              top: 90px;
              left: 36px;
              color: #EFB040
            }
          }
          .danger{
            border: 2px solid #D54941;
            .txt{
              position: absolute;
              top: 90px;
              left: 43px;
              color: #D54941;
              width: 70px;
              height: 44px;
              line-height: 22px;
              word-wrap: break-word;
            }
          }
        }
      }
      .code-btn {
        position: absolute;
        right: 1px;
        top: 1px;
        height: 39px;
        .right-btn {
          border-radius: 0 4px 4px 0;
          border: none;
        }
        .icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
      .code-icon{
        position: absolute;
        right: 16px;
        top: 1px;
        height: 39px;
        .icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
        .icon-noeye{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .alert{
        color: #D54941;
        font-size: 12px;
      }
      .signVerifySubmitBtn{
        width: 60%;
      }

      .wancheng{
        text-align: center;
        img {
          width: 84px;
          height: 84px;
        }
        .txt{
          margin-top: 8px;
          margin-bottom: 24px;
        }
        .fanhui{
          width: 140px;
        }

      }
    }
    .signVerify-footer{
      position: absolute;
      right: 70px;
      bottom: 60px;
      .dunpai{
        width: 100%;
        height: 100%;
      }
    }

    .singVerify-success{
      text-align: center;
      img{
        width: 126px;
        height: 128px;
        margin-top: 60px;
      }
      .p1{
        padding-top: 50px;
        padding-bottom: 20px;
        font-size: 14px;
      }
      .p2{
        color: #999999;
        font-size: 14px;
        padding-bottom: 120px;
      }

    }
  }
  .sidExpired{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    font-size: 20px;
    img{
      width: 84px;
      height: 84px;
    }
  }
}
.select-sign {
	// width: 152px;
	//margin: 20px 26px;
	margin: 20px 12px 20px 20px;
  border-radius: 6px 6px 6px 6px;
  border: 1.5px dashed #D8DAEA;
  position: relative;
	text-align: center;
  .qifeng{
    width: 60px;
    height: 60px;
    position: absolute;
    top: 1px;
    right: 1px;
  }
}

.select-sign-title {
	font-size: 14px;
	color: #666666;
	text-align: center;
}

.sign-item {
	// width: 46px;
	text-align: center;
	font-size: 0;
	display: inline-block;
	margin: 20px;

	.sign-img-box {

		// &[data-seal-type="companyCommon"] {
		//   width: 109px;
		// }
		&[data-seal-type="person"] {
			width: 64.5px;
		}

		// width: 109px;
		width: 128px;
		text-align: center;
		//border: 1px solid #f0f0f5;
		border-radius: 4px;
		font-size: 0;
		cursor: grab;

		img {
			max-width: 100%;
			height: auto;
			vertical-align: middle;
			user-select: none;
		}

    &[data-seal-type="companyCommon"] {
      /deep/ img{
        max-height: 140px;
        margin: 20px auto;
      }
    }
	}

	span {
		display: inline-block;
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		margin-top: 5px;
	}
}



.tabTitle-box{
  flex-shrink:0;
  width: calc(100% - 238px - 238px );
  .tabTitle{
    background-color: #fff;
    //overflow-y: hidden;
    //overflow-x: scroll;
    display: flex;
    .item{
      cursor: pointer;
      padding-right: 17px;
      border-right:1px solid #F2F3F5;
      height: 32px;
      line-height: 32px;
      //display: inline-block;

      flex-shrink: 0;
      img {
        width: 8px;
        height: 10px;
        margin-right: 10px;
        margin-left: 16px;

      }
      .txt{
        color: #86909C;
      }
    }
    .active{
      .txt{
        color: #3F7BF9;
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }

  }

}


.contract-container {
  position: relative;
  height: calc(100vh - 54px);
  //width: calc(100% - 240px * 2 - 40px);
  margin-right: 20px;
  margin-left: 20px;
  max-width: 714px;
  margin: 0 auto;
}
.contract-content {
	/* width: 685px; */
	background: #f0f0f5;
	/* position: relative; */
	 height: calc(100vh - 110px);
	//height: 100vh;
  //padding-bottom: 100px;
  margin-top: 20px;

	overflow-y: auto;
	overflow-x: auto;
	/* overflow: auto; */

	.drag-box {
		// background: rgba(255, 255, 255, 0.7);
		// border-radius: 10px;
		// overflow: hidden;

		&.sign-box {
			// width: 109px;
			// height: 109px;
			// margin: 8px auto;
			width: 140px;
			margin: auto;

			/deep/ img {
				display: block;
				max-width: 100%;
				height: auto;
				user-select: none;
			}
			// border: 1px solid #33cccc;
		}

		&.sign-box[data-seal-type="person"] {
			width: 63.5px;
      /deep/ img{
        height: 100%;
        margin: 0 auto;
      }
			// height: 93.5px;
			// border: 1px solid #33cccc;
		}
    &.sign-box[data-seal-type="companyCommon"] {
			/deep/ img{
        //height: 100%;
        max-height: 140px;

        margin: 0 auto;
      }
		}
    &.sign-box[data-seal-type="companyLegal"] {
      /deep/ img{
        //height: 100%;
        max-height: 70px;
        margin: 0 auto;
      }
    }
    &.sign-box[data-seal-type="companyAgent"] {
      /deep/ img{
        //height: 100%;
        max-height: 70px;

        margin: 0 auto;
      }
    }

		&.sign-box[data-type="paging"] {

			transform: translateX(50%);

			/deep/ .box-head {
				right: 50%;
			}
		}

		// &.seal-box {
		// 	width: 127px;
		// 	height: 157px;
		// 	border: 1px solid #33cccc;
		// }
		// &.date-box {
		// 	width: 127px;
		// 	height: 66px;
		// 	border: 1px solid #33cccc;
		// }
    &.highlight {
      outline: 4px solid rgba(84, 137, 249, 0.2);
      transition: outline-width ease .1s;
    }
		/deep/ .box-head {
			color: #f56c6c;

			display: flex;
			justify-content: space-between;
			align-items: center;
			position: absolute;
			right: -9px;
			top: -9px;

			.el-icon-circle-close {
				font-weight: bold;
				font-size: 26px;
				cursor: pointer;
			}
		}
	}
}

.contract-page {
	min-width: 175px;
	width: 238px;
	background: #fff;
	// height: calc(100vh - 128px);
	height: 100vh;
	overflow: hidden;
	border-left: 1px solid #EBEEF5;

	.el-collapse {
		max-height: calc(100% - 110px);

		/deep/ .el-collapse-item {
			// height: 100%;
			.el-collapse-item__header {
				padding: 0 10px 0 15%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 95%;
				display: block;
				position: relative;

				.el-collapse-item__arrow {
					position: absolute;
					left: 5%;
					top: 0;
					bottom: 0;
					margin: auto 0;
					width: 13px;
					height: 13px;
				}
			}

			.el-collapse-item__wrap {

				// height: calc(100% - 48px);
				.el-collapse-item__content {
					overflow: auto;
					background: #f9f9ff;
					padding-top: 25px;
					//padding-bottom: 1px;
					padding-bottom: 58px;
				}
			}
		}
	}

	.pages-head {
		height: 45px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 17px;
		padding-right: 13px;
		background: #ffffff;

		.big {
			font-size: 16px;
			font-weight: bold;
			color: #333333;
		}

		.sub {
			font-size: 14px;
			font-weight: 400;
			color: #999999;
		}
	}

	.page-wrap {
		width: 160px;
		margin: 0 auto;

		img {
			display: block;
			margin: 0 auto;
			width: 100%;

			&.current {
				outline: 1px solid #3699ff;
				box-shadow: 0px 3px 10px 0px rgba(54, 153, 255, 0.1);
			}
		}

		.page {
			font-size: 12px;
			font-weight: 400;
			color: #999999;
			text-align: center;
			margin: 12px 0;

			&.current {
				color: #3699ff;
			}
		}
	}

	/* overflow-y: auto; */
	/* overflow-x: hidden; */
}

#sign-layer {
	background: #f0f0f5;
	height: 100vh;
	overflow: hidden;
}

header {
	width: 100%;
	height: 71px;
	background: rgba(35, 43, 58, 1);
	box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
	line-height: 71px;
	overflow: hidden;
}

.header-center {
	width: 1200px;
	margin: 0 auto;
	line-height: 71px;
	height: 71px;
	overflow: hidden;
	position: relative;
}

.return-index {
	height: 71px;
	display: block;
	position: absolute;
	right: 0;
	top: 0;
	font-size: 24px;
	color: #ffffff;
	line-height: 71px;
}

.setcontrol-content {
	//max-width: 1200px;
	//margin: 0 auto 0;
	// margin: 30px auto 0;
	display: flex;
	justify-content: space-between;
	position: relative;
	//width: 100%;
}

.set-sign-control {
	width: 240px;
	min-width: 175px;
	background: white;
	position: relative;
	z-index: 9;
	//overflow-y: auto;
	// height: calc(100vh - 128px);
	//height: 100vh;
	//border-right: 1px solid #EBEEF5;

	/deep/ .el-collapse-item {
		// height: 100%;
		.el-collapse-item__header {
			padding: 0 10px 0 15%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			width: 95%;
			display: block;
			position: relative;

			.el-collapse-item__arrow {
				position: absolute;
				left: 5%;
				top: 0;
				bottom: 0;
				margin: auto 0;
				width: 13px;
				height: 13px;
			}
		}

		.el-collapse-item__wrap {

			// height: calc(100% - 48px);
			.el-collapse-item__content {
				overflow: auto;
				background: #f9f9ff;
				padding-top: 25px;
				padding-bottom: 1px;
			}
		}
	}

	.pages-head {
		width: 100%;
		height: 45px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 17px;
		padding-right: 13px;
		border-top: 1px solid #EBEEF5;
		border-bottom: 1px solid #EBEEF5;

		.big {
			font-size: 16px;
			font-weight: bold;
			color: #333333;
		}

		.sub {
			font-size: 14px;
			font-weight: 400;
			color: #999999;
		}
	}
}
.sign-guide {
  padding: 18px 20px 20px;
  font-size: 12px;
  font-weight: 500;
  color: #4E5969;
  border-bottom: 1px solid #F2F3F5;

  .guide-content {
    font-size: 12px;
    font-weight: 400;
    color: #86909C;
    line-height: 22px;
    margin-top: 7px;
    position: relative;
  }

  .guide-detail {
    font-size: 12px;
    font-weight: 400;
    color: #E89400;
    line-height: 22px;
    // position: absolute;
    // right: 0;
    // bottom: 0;
  }
}
.seal-list-wrap{
  height: calc(100vh - 212px);
  margin-bottom: 100px;
  padding: 0 30px 20px;
  .select-sign {
    width: 180px;
    height: 180px;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    border: 1.5px dashed #D8DAEA;
    position: relative;
    margin: 0px;

    &[data-seal-type="companyCommon"] {
      width: 180px;
      height: 180px;
    }

    &[data-seal-type="companyLegal"] {
      width: 180px;
      height: 90px;

      img {
        max-height: 70px;
      }
    }

    &[data-seal-type="companyAgent"] {
      width: 180px;
      height: 90px;

      img {
        max-height: 70px;
      }
    }

    &[data-seal-type="person"] {
      width: 180px;
      height: 90px;

      img {
        max-height: 70px;
      }
    }

    &[data-seal-type="date"] {
      width: 180px;
      height: 60px;

      img {
        max-height: 40px;
      }
    }
  }

  .group-item-title {
    font-size: 15px;
    font-weight: 500;
    color: #313843;
    display: flex;
    align-items: center;
    padding-top: 20px;
    margin-bottom: 20px;
  }
  .qifengzhang{
    color: #313843;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 180px;
    margin-bottom: 20px;
  }
  .seal-name {
    font-size: 13px;
    font-weight: 400;
    color: #424E66;
    margin: 12px auto 16px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tag {
    display: inline-block;
    width: 48px;
    height: 20px;
    line-height: 18px;
    background: #F5FBF5;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    border: 1px solid #B9E2C6;
    font-size: 12px;
    font-weight: 400;
    position: absolute;
    top: 8px;
    right: 8px;

    &.authed {
      background: #F5FBF5;
      border: 1px solid #B9E2C6;
      color: #38A65A;
    }

    &.process {
      background: #FFF8F9;
      border: 1px solid #FFCACD;
      color: #EB6069;
    }

    &.forbid {
      background: #F2F3F5;
      border: 1px solid #C4CEDB;
      color: #86909C;
    }
  }

  .sign-item {
    // width: 46px;
    text-align: center;
    font-size: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px;

    .sign-img-box {

      // &[data-seal-type="companyCommon"] {
      //   width: 109px;
      // }
      // &[data-seal-type="person"] {
      //   width: 64.5px;
      // }

      // width: 109px;
      width: 140px;
      text-align: center;
      font-size: 0;

      img {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
        user-select: none;
      }
    }

    span {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-top: 5px;
    }
  }
}
.magic-btn-wrap {
  padding: 16px 0 0;
  position: relative;

  .magic-btn {
    width: 100%;
    height: 36px;
    background: #3F7BF9 linear-gradient(90deg, #5890FF 0%, #256BFF 100%);
    border-radius: 6px 6px 6px 6px;
    padding: 0;
    line-height: 36px;

    /deep/ span {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
  }
}
.auto-seal-btn-wrap {
	text-align: center;
	padding: 0 0 25px;
}

.auto-seal-btn {
	width: 128px;
	// position: absolute;
	// left: 50%;
	// top: unset;
	// transform: translateX(-50%);
}

.set-title {
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	border-left: 3px solid #3699ff;
	text-indent: 13px;
	margin: 20px 0 0 27px;

	.tag {
		padding: 1px 4px;
		border: 2px solid #3699ff;
		border-radius: 7px;
		font-size: 12px;
		font-weight: bold;
		color: #3699ff;
		display: inline-block;
		text-indent: 0;
		text-align: center;
		margin-left: -9px;
		margin-right: 11px;

		&.process {
			border: 2px solid #00d9d6;
			color: #00d9d6;
		}
	}
}

.set-title-padding {
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	margin: 12px 27px 12px 27px;

	&+.set-title-padding {
		margin-top: 0;
	}
}

.contract-img-content {
	/* height: calc(100vh - 134px);
	overflow-y: auto;
	position: relative; */

	/* position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 2; */

	height: 100%;
}

.contract-imgs {
	position: relative;
	z-index: 1;

	.file-item {
		//width: 665px;
		overflow: hidden;
	}
}

.contract-imgs .contract-img {
	display: block;
	width: 700px;
	height: auto;
	/* border-bottom: 2px solid #eee; */
	box-sizing: content-box;
	-ms-box-sizing: content-box;
}

.contract-imgs .orther-box-sign {
	max-width: 80px;
	max-height: 80px;
}

//.contract-imgs .img-wrap {
//	position: relative;
//  width: 700px;
//  margin: 0 auto;
//
//	.position-box {
//		position: absolute;
//		overflow: hidden;
//
//		// border-radius: 10px;
//		&[data-type="paging"] {
//			// border-radius: 10px 0 0 10px;
//		}
//
//		.sign-pos-box {
//			width: 64.5px;
//			height: 64.5px;
//			border: 1px solid #33cccc;
//			background: rgba(255, 255, 255, 0.7);
//			// border-radius: 10px;
//			// overflow: hidden;
//		}
//
//		.seal-pos-box {
//			//width: 128px;
//			//height: 128px;
//      width: 128px;
//      height: 158px;
//			border: 1px solid #33cccc;
//			background: rgba(255, 255, 255, 0.7);
//			// border-radius: 10px;
//			overflow: hidden;
//		}
//
//		.date-pos-box {
//			width: 128px;
//			height: 31px;
//			border: 1px solid #33cccc;
//			background: rgba(255, 255, 255, 0.7);
//			// border-radius: 10px;
//			overflow: hidden;
//		}
//
//		.paging-pos-box {
//			width: 50px;
//			height: 128px;
//			border: 1px solid #33cccc;
//			background: rgba(255, 255, 255, 0.7);
//			// border-radius: 10px 0 0 10px;
//			overflow: hidden;
//
//			/deep/ .box-head {
//				span {
//					position: absolute;
//					top: 40px;
//					left: 4px;
//					color: #aaa;
//				}
//			}
//		}
//
//		/deep/ .box-head {
//			width: 100%;
//			min-height: 30px;
//			color: #fff;
//			background: #33cccc;
//			font-size: 12px;
//			display: flex;
//			justify-content: space-between;
//			align-items: center;
//			padding: 0 3px 0 8px;
//			position: absolute;
//			left: 0;
//			top: 0;
//
//			.el-icon-close {
//				cursor: pointer;
//				padding: 5px;
//			}
//		}
//	}
//}
.contract-imgs .img-wrap {
  // width: 793px;
  position: relative;
  // width: 100%;
  // min-width: 793px;
  width: 700px;
  margin: 0 auto;

  .position-box {
    position: absolute;
    // overflow: hidden;

    border-radius: 6px;
    border: 1.5px dashed #448DF7;
    background: rgba(68, 141, 247, 0.05);
    transition: outline-width ease .1s;

    // &:focus {
    //   outline: 4px solid rgba(84, 137, 249, 0.2);
    // }

    &.highlight {
      outline: 4px solid rgba(84, 137, 249, 0.2);
      transition: outline-width ease .1s;
    }

    &.has-seal:hover {

      /deep/ .el-icon-close,
      /deep/ .seal-name {
        display: block;
      }
    }

    &.has-seal .box-head {
      display: none;
    }
    .paging-pos-box {
      &.has-seal:hover {

        /deep/ .el-icon-close,
        /deep/ .seal-name {
          display: block;
        }
      }

      &.has-seal .box-head {
        display: none;
      }
    }

    // &.has-seal.active {
    // &.active {
    //   background: rgba(255, 255, 255, 0.05) !important;
    //   border-style: solid;
    // }


    &:active {
      background: rgba(255, 255, 255, 0.05) !important;
      border-style: solid;
    }

    /deep/ .seal-name {
      display: none;
      position: absolute;
      bottom: -28px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;

      width: 136px;
      min-height: 19px;
      background: #F6F6F6;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #E7E7E7;

      font-size: 10px;
      font-weight: 400;
      color: #4E5969;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /deep/ .el-icon-close {
      display: none;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: #EB6069;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      color: #fff;
      font-size: 12px;
      position: absolute;
      top: -7px;
      right: -7px;
      z-index: 99;
      // padding: 5px;
      // position: absolute;
      // right: 5px;
    }

    &[data-type="paging"] {
      border-radius: 6px 0 0 6px;
    }

    .sign-pos-box {
      width: 140px;
      height: 70px;
    }

    .seal-pos-box {
      width: 140px;
      height: 140px;
    }

    .date-pos-box {
      width: 140px;
      height: 40px;



      /deep/ .box-head {
        flex-direction: row;

        span {
          margin-top: 0;
          margin-left: 7px;
        }
      }
    }

    .paging-pos-box {
      width: 70px;
      height: 140px;
      // border-radius: 10px 0 0 10px;
      overflow: hidden;

      // /deep/ .box-head {
      //   span {
      //     position: absolute;
      //     top: 40px;
      //     left: 4px;
      //     color: #aaa;
      //   }
      // }


      /deep/ .el-icon-close {
        left: -7px;
        right: unset;
      }
    }

    /deep/ .box-head {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 48%;
      font-size: 0;
      transform: translate(-50%, -50%);

      span {
        font-size: 10px;
        font-weight: 400;
        color: #86909C;
        margin-top: 4px;
        white-space: nowrap;
      }
    }

    // /deep/ .box-head {
    //   width: 100%;
    //   min-height: 30px;
    //   color: #fff;
    //   background: #3296FA;
    //   font-size: 12px;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   padding: 0 3px 0 8px;
    //   position: absolute;
    //   left: 0;
    //   top: 0;

    //   .el-icon-close {
    //     cursor: pointer;
    //     padding: 5px;
    //   }
    // }
  }
}

.contract-imgs .img-wrap+.img-wrap {
	margin-top: 30px;
}

/* .contract-img {
																																																																																																								width: 685px;
																																																																																																							} */

.custom-drag {
	width: 127px;
	height: 127px;
	border: 1px solid rgba(51, 204, 204, 1);
	position: absolute;
	left: 0;
	top: 0;
	z-index: 3;
	cursor: move;
	/* box-sizing: content-box;
																																																																																																								-ms-box-sizing: content-box; */
}

.custom-content {
	width: 127px;
	height: 127px;
	background: rgba(255, 255, 255, 0.7);
	position: relative;
	z-index: 1;
}

.custom-drag-title {
	font-size: 16px;
	color: #000000;
	display: block;
	width: 127px;
	top: 50px;
	display: block;
	position: absolute;
	z-index: -1;
	text-align: center;
}

.custom-drag-time {
	position: absolute;
	bottom: 8px;
	text-align: center;
	font-size: 16px;
	color: #bbb;
	display: block;
	width: 127px;
	z-index: 9999;
}

.custom-drag-header {
	width: 109px;
	height: 33px;
	background: rgba(51, 204, 204, 1);
	line-height: 33px;
	font-size: 16px;
	color: #ffffff;
	padding: 0 10px;
	/* display: flex;
																																																																																																								justify-content: space-between; */
	position: absolute;
	left: -1px;
	top: -33px;
}

.custom-drag-header .delete {
	cursor: pointer;
	float: right;
	margin-right: 5px;
}

.custom-delete {
	font-size: 14px;
	width: 60px;
	height: 22px;
	background: rgba(0, 0, 0, 0.5);
	text-align: center;
	color: #ffffff;
	display: block;
	line-height: 22px;
	position: absolute;
	left: 30px;
	bottom: -22px;
	display: none;
}

.all-page {
	width: 180px;
	margin: 30px auto 0;
}

.page-item {
	position: relative;
	height: 230px;
	margin-bottom: 22px;
}

.page-img {
	width: 177px;
	height: 238px;
	border: 1px solid rgba(240, 240, 245, 1);
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	cursor: pointer;
	position: relative;
}

.page-img img {
	display: block;
	max-width: 177px;
	max-height: 198px;
}

.page-text {
	text-align: center;
	font-size: 14px;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	color: #333333;
}

.sign-default,
.sign-orther {
	width: 152px;
	height: 152px;
	background: #f9f9f9;
	overflow: hidden;
	margin-top: 30px;
}

.sign-default-title {
	text-align: center;
	font-size: 14px;
	color: #999999;
	line-height: 34px;
}

.default-box,
.orther-sign-box {
	width: 80px;
	height: 80px;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 5px auto 0;
	background: #ffffff;
	border: 1px solid rgba(229, 229, 229, 1);
	/* position: relative; */
}

.default-box img,
.orther-box .orther-box-sign {
	display: block;
	max-width: 80px;
	max-height: 80px;
	cursor: move;
}

/* .personal{
																																																																																																							background: url('../../assets/images/sign/personal.png') no-repeat right top;
																																																																																																							} */

.type-icon {
	position: relative;
	left: 88px;
	top: -81px;
	/* transform: translateY(-50px); */
}

.sign-name {
	font-size: 14px;
	color: #333333;
	text-align: center;
	line-height: 34px;
	margin-top: -6px;
}

.orther-title {
	text-align: center;
	font-size: 16px;
	color: #333333;
	margin-top: 30px;
}

.sign-orther {
	width: 152px;
	margin: 15px auto 0;
}

.sign-orther {
	margin-top: 0;
}

.orther-box {
	margin-top: 20px;
	margin-bottom: 10px;
	height: 114px;
}

.orther-list {
	margin-top: 15px;
	padding-bottom: 40px;
}

.custom-sign-box {
	width: 127px;
	height: 127px;
	position: absolute;
	top: 0;
	left: 0;
	/* border: 1px solid red; */
	overflow: hidden;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
}

.custom-sign-box img {
	display: block;
	max-height: 127px;
	max-width: 127px;
}

.submit-btn {
	width: 279px;
	height: 42px;
	position: fixed;
	left: 50%;
	bottom: 50px;
	// margin-left: -168px;
	color: #ffffff;
	font-size: 16px;
	z-index: 999;
	transform: translateX(-50%);
}

.submit-btn button {
	width: 100%;
	display: block;
	font-size: 16px;
	float: left;
}

.page-img .sign-icon {
	width: 44px;
	height: 44px;
	position: absolute;
	right: 0;
	top: 0;
}

.sign-auth {
	text-align: center;
	font-size: 12px;
	color: red;
	margin-top: -40px;
	height: 17px;
}

.default {
	margin-top: -55px;
}

.drag-box /deep/ .delete-icon {
	font-size: 28px;
	position: absolute;
	color: #fff;
	font-weight: bold;
	right: 1px;
	top: 1px;
	display: none;
	cursor: pointer;
	background: red;
	border-radius: 50%;
}

.paging-pos-box .drag-box /deep/ .delete-icon {
	right: unset;
	top: -8px;
	left: 10px;
}

.drag-box:hover /deep/ .delete-icon {
	display: block;
}
.page-indicator {
  // width: 32px;
  min-height: 32px;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #F2F2F3;
  position: absolute;
  bottom: 206px;
  right: 36px;
  z-index: 9999;
  user-select: none;
  padding: 4px 0;

  cursor: pointer;

  .page-icon {
    padding: 4px 0;
    width: 32px;
    height: 24px;

    .page-icon-inner {
      display: block;
      margin: 0 auto;
    }

    .page-icon-inner.active {
      display: none;
    }

    &:hover {
      .page-icon-inner {
        display: none;
      }

      .page-icon-inner.active {
        display: block;
      }
    }
  }
}

.locate-indicator {
  width: 32px;
  height: 32px;
  background: linear-gradient(180deg, #E5EEFF 0%, #FFFFFF 100%);
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E4ECFF;

  position: absolute;
  bottom: 160px;
  right: 36px;
  z-index: 9999;
  user-select: none;

  cursor: pointer;

  .badge {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #EB6069;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    line-height: 20px;
    position: absolute;
    right: -10px;
    top: -10px;
  }

  .locate-icon {
    width: 32px;
    height: 32px;
  }

  .locate-icon-inner {
    display: block;
    margin: 0 auto;
  }

  .locate-icon-inner.active {
    display: none;
  }


  &:hover {
    .locate-icon-inner {
      display: none;
    }

    .locate-icon-inner.active {
      display: block;
    }
  }
}
</style>
<style lang="scss" scoped>
#draw-seal {
	width: 100%;
	height: 400px;
	user-select: none;
	position: relative;
}

#seal-canvas {
	/* width: 100%;
	height: 100%;
	background: white;
	position: absolute;
	left: 0;
	top: 0; */
	background: white;
}

.draw-tip {
	font-size: 14px;
	position: absolute;
	left: 50%;
	top: 50%;
	letter-spacing: 2px;
	text-align: center;
	transform-origin: 0 0;
	transform: translate(-50%, -50%);
}

.draw-tip img {
	display: inline-block;
	width: 30px;
}

.draw-tip p {
	margin-top: 14px;
	color: #666666;
}

.tip-success,
.tip-waning {
	width: 100%;
	position: fixed;
	left: 0;
	top: -0.8rem;
	background: #f0f9eb;
	z-index: 999;
	color: #67c23a;
	font-size: 0.16rem;
	text-align: center;
	height: 0.8rem;
	line-height: 0.8rem;
	transition: 0.5s;
}

.tip-waning {
	background: #fdf6ec;
	color: #e6a23c;
}

.handwrite-img-wrap {
	text-align: center;
	font-size: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.handwrite-img-wrap .drag-box {
	width: 64.5px;
	border: 1px solid #f0f0f5;
	border-radius: 4px;
}

.drag-box+.el-button {
	margin-left: 15px;
}

.handwrite-img-wrap img {
	display: block;
	width: 100%;
	height: auto;

}

.auto-seal-wrap {
	.set-title {
		margin: 20px 0 20px 0;
	}


	.auto-seal-list {
		display: grid;
		grid-gap: 1rem;
		grid-template-columns: repeat(auto-fit, minmax(128px, 0));
	}

	.auto-seal-item {
		width: 128px;
		border: 2px solid transparent;
		border-radius: 10px;
		padding: 10px;
		position: relative;
		cursor: pointer;

		img {
			max-width: 100%;
			height: auto;
			vertical-align: middle;
			user-select: none;
		}

		&.isCheck {
			border: 2px solid #409EFF;
		}

		i {
			position: absolute;
			right: 5px;
			bottom: 5px;
			color: #409EFF;
			font-size: 22px;
		}

	}


}
/*
验证方式弹窗
*/
.authMethodType {
  /deep/ .el-dialog__header{
    background-color: #F9FAFD;
    padding: 16px 20px;
    border-radius: 20px 20px 0px 0px;
    .el-dialog__headerbtn{
      top: 16px;
    }
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  /deep/ .el-form .el-form-item:last-child{
    margin-bottom: 0px;
  }
  .authMethodType_footer{
    .btns{
      text-align: right;
    }
    .otherAuthType{
      display: flex;
      justify-items: left;
      align-items: center;
      height: 44px;
      line-height: 44px;
      margin-top: 20px;
      padding-top: 20px;
      border-top:2px dashed #D8D8D8;;
      .img{
        width: 12px;
        height: 14px;
        margin-right: 10px;
        cursor: pointer;
      }
      .img:hover{
        opacity: 0.8;
      }
      .txt{
        margin-right: 40px;
        color: #3F7BF9;
        font-size: 14px;
        cursor: pointer;
      }
      .txt:hover{
        opacity: 0.8;
      }
    }
  }
  .code-btn {
    position: absolute;
    right: 1px;
    top: 1px;
    height: 39px;
    .right-btn {
      border-radius: 0 4px 4px 0;
      border: none;
    }
    .icon{
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  .code-icon{
    position: absolute;
    right: 16px;
    top: 3px;
    height: 39px;
    .icon{
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
    .icon-noeye{
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  .alert{
    color: #D54941;
    font-size: 12px;
  }
  .qrcode-box{
    width: 160px;
    height: 160px;
    margin: 0 auto;
    position: relative;
    .code-img{
      width: 160px;
      height: 160px;
      vertical-align: baseline;
    }
    .mask{
      width: 160px;
      height: 160px;
      border-radius: 6px;
      background: rgba(255,255,255,0.9);
      margin: 0 auto;
      position: absolute;
      top: 0;
      left: 0;
      .icon{
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50px;
        left: 60px;
      }

    }
    .success{
      border: 2px solid #38A65A;
      .txt{
        position: absolute;
        top: 90px;
        left: 57px;
        color: #38A65A
      }
    }
    .warning{
      border: 2px solid #EFB040;
      .txt{
        position: absolute;
        top: 90px;
        left: 36px;
        color: #EFB040
      }
    }
    .danger{
      border: 2px solid #D54941;
      .txt{
        position: absolute;
        top: 90px;
        left: 43px;
        color: #D54941;
        width: 70px;
        height: 44px;
        line-height: 22px;
        word-wrap: break-word;
      }
    }

  }
  .shuaxin{
    width: 66px;
    height: 27px;
    line-height: 26px;
    border: 1px solid #E7E9EE;
    border-radius: 40px;
    margin: 0 auto;
    cursor: pointer;
  }
}
.el-drawer.auto-seal-drawer  {
  .el-drawer__body{
    overflow: hidden;
    .auto-seal-wrap{
      padding-left: 40px;
      height: calc(100% - 62px);
      overflow: auto;
      .set-title-drawer {
        font-size: 15px;
        font-weight: 500;
        color: #313843;
        display: flex;
        align-items: center;
        padding-top: 20px;
        margin-bottom: 20px;
      }


      .auto-seal-list {
        display: grid;
        grid-gap: 0 40px;
        grid-template-columns: repeat(auto-fit, minmax(180px, 0));
      }

      .auto-seal-item-draw {
        border-radius: 10px;
        position: relative;
        cursor: pointer;

        .seal-name {
          font-size: 13px;
          font-weight: 400;
          color: #424E66;
          margin: 12px auto 16px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }


        .select-sign-draw {
          width: 180px;
          height: 180px;
          background: #FFFFFF;
          border-radius: 6px 6px 6px 6px;
          border: 1.5px dashed #D8DAEA;
          position: relative;

          i {
            position: absolute;
            right: 10px;
            bottom: 10px;
            color: #468DFF;
            width: 20px;
            height: 20px;
            line-height: 20px;
            background: #FFFFFF;
            border-radius: 50%;
            text-align: center;

            &.check-fill {
              background: #468DFF;
            }

            &.check-circle {
              display: none;
              border: 1.5px solid #3F7BF9;
            }
          }



          &:hover {
            border-color: #3F7BF9;

            i.check-circle {
              display: block;
            }
          }

          &.isCheck {
            border-color: #3F7BF9;
            border-style: solid;
          }

          img {
            max-width: 100%;
            height: auto;
            vertical-align: middle;
            user-select: none;
          }


          &[data-seal-type="companyCommon"] {
            width: 180px;
            height: 180px;
          }

          &[data-seal-type="companyLegal"] {
            width: 180px;
            height: 90px;

            img {
              max-height: 70px;
            }
          }

          &[data-seal-type="companyAgent"] {
            width: 180px;
            height: 90px;

            img {
              max-height: 70px;
            }
          }

          &[data-seal-type="person"] {
            width: 180px;
            height: 90px;

            img {
              max-height: 70px;
            }
          }

          &[data-seal-type="date"] {
            width: 180px;
            height: 60px;

            img {
              max-height: 40px;
            }
          }

          .sign-item-draw {
            width: 140px;
            text-align: center;
            font-size: 0;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: auto;

            img {
              max-width: 100%;
              height: auto;
              vertical-align: middle;
              user-select: none;
            }

            span {
              display: inline-block;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              margin-top: 5px;
            }
          }

          .tag {
            display: inline-block;
            width: 48px;
            height: 20px;
            line-height: 18px;
            background: #F5FBF5;
            border-radius: 4px 4px 4px 4px;
            text-align: center;
            border: 1px solid #B9E2C6;
            font-size: 12px;
            font-weight: 400;
            position: absolute;
            top: 8px;
            right: 8px;

            &.authed {
              background: #F5FBF5;
              border: 1px solid #B9E2C6;
              color: #38A65A;
            }

            &.process {
              background: #FFF8F9;
              border: 1px solid #FFCACD;
              color: #EB6069;
            }

            &.forbid {
              background: #F2F3F5;
              border: 1px solid #C4CEDB;
              color: #86909C;
            }
          }



        }

      }
    }
    .drawer-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 20px;
      border-top: 1px solid #E7E7E7;

      font-size: 14px;
      font-weight: 400;
      color: #86909C;

      .el-button {
        width: 92px;
        height: 32px;
      }
    }
  }
}
</style>
<style>
.handwrite-dialog {
	user-select: none;
}

.handwrite-dialog .el-dialog__body {
	padding: 0;
}

.autoseal-dialog .el-dialog__body {
	padding: 0 20px 30px;
}
.el-popper.light-popper {
  width: 180px;
  height: 70px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px 4px 4px 4px;
  padding: 8px 8px 26px;

  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 18px;


}

/* .light-popper p {
  line-height: 18px;
} */

.light-popper.el-popper[x-placement^=bottom] .popper__arrow:after {
  border-bottom-color: rgba(0, 0, 0, 0.6);
}

.light-popper>div:nth-of-type(1) {
  margin-top: -2px !important;
}

.light-popper .el-button--text {
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  opacity: .5;
}

.light-popper .el-button--text:hover {
  opacity: .8;
}

</style>
